
import Dashboard from 'layouts/dashboard';
import { QuestionAnswer, WallpaperRounded, WorkspacePremium } from '@mui/icons-material';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import Products from 'layouts/products';
import Inventory from 'layouts/inventory';
import Members from 'layouts/members';
import Brands from 'layouts/brands';
import Regions from 'layouts/regions';
import Orders from 'layouts/orders';
import AddMember from 'layouts/members/addMember';
import MemberDetails from 'layouts/members/memberDetails';
import AddProduct from 'layouts/products/addProduct';
import Categories from 'layouts/categories';
import AddRegion from 'layouts/regions/addRegion';
import AddCategory from 'layouts/categories/addCategory';
import AddInventory from 'layouts/inventory/addInventory';
import AddOrder from 'layouts/orders/addOrder';
import AddBrand from 'layouts/brands/addBrand';
import ProductIcon from 'common/customIcons/product';
import InventoryIcon from 'common/customIcons/inventory';
import OrdersIcon from 'common/customIcons/orders';
import DashboardIcon from 'common/customIcons/dashboard';
import MembersIcon from 'common/customIcons/members';
import BrandsIcon from 'common/customIcons/brands';
import CategoriesIcon from 'common/customIcons/categories';
import SettingsIcon from 'common/customIcons/settings';
import DistributionConfigIcon from 'common/customIcons/distributionConfig';
import AgingDiscountedProductsIcon from 'common/customIcons/agingDiscountedProducts';
import KitTemplateIcon from 'common/customIcons/kitTemplate';
import DistributionManagementIcon from 'common/customIcons/distributionManagement';
import KitRefillLogsIcon from 'common/customIcons/kitRefillLogs';
import DriverKitVerificationIcon from 'common/customIcons/driverKitVerification';
import AddWebCategory from 'layouts/manageCategories/addWebCategory';
import ProductDetails from 'layouts/products/productDetails';
import HyperwolfProductDetails from 'layouts/hyperwolf/products/productDetails';
import OrderDetailsPage from 'layouts/orders/orderDetails';
import TerpenesIcon from 'common/customIcons/terpenes';
import RegionsIcon from 'common/customIcons/regions';
import Strains from 'layouts/strains';
import AddStrain from 'layouts/strains/addStrain';
import AddMainStrain from 'layouts/strains/addMainStrain';
import StrainsIcon from 'common/customIcons/strains';
import MemberOrders from 'layouts/orders/memberOrders';
import AddMainBrand from 'layouts/brands/addMainBrand';
import ManageSignupType from 'layouts/manageSingupType';
import ManageRegisterationIcon from 'common/customIcons/manage_registeration';
import MainFAQ from 'layouts/mainFAQ';
import HomepageBanners from 'layouts/mainBanners';
import AddBanner from 'layouts/mainBanners/AddBanner';
import Promotions from 'layouts/promotions';
import AddPromotion from 'layouts/promotions/addPromotion';
import PromotionDetails from 'layouts/promotions/promotionDetails';
import PromotionsIcon from 'common/customIcons/promotions';
import ManageDisclaimers from 'layouts/disclaimers';
import MemberShips from 'layouts/memberships';
import AddMemberShip from 'layouts/memberships/addMemberShip';
import StoreProductDetailsPage from 'components/stores/Products/productDetails';
import MasterCatalogProductList from 'layouts/masterCatalog/MasterCatalog';
import MasterCatalog from 'layouts/masterCatalog';
import AddStoreProducts from 'components/stores/addStoreProducts';
import Approvals from 'layouts/approvals';
import StoreApprovalDetails from 'components/stores/Approvals/approvalDetails';
import ApprovalsIcon from 'common/customIcons/approvals';
import MastercatalogIcon from 'common/customIcons/master-catlog';
import HyperDrive from 'layouts/Hyperdrive';
import HyperwolfAdmin from 'layouts/hyperwolf';
import DriverIcon from 'common/customIcons/driver';
import ManageHyperwolfCategories from 'layouts/hyperwolf/manageCategories';
import ManageEmployees from 'layouts/hyperwolf/manageEmployee';
import AddEmployee from 'layouts/hyperwolf/manageEmployee/AddEmployee';
import HyperwolfShopTiming from 'layouts/hyperwolf/manageShopTimings';
import HyperwolfRegions from 'layouts/hyperwolf/regions';
import AddHyperwolfSubRegion from 'layouts/hyperwolf/regions/components/addSubRegion';
import ViewHyperwolfRegion from "layouts/hyperwolf/regions/components/viewRegion";
import AddHyperwolfRegion from "layouts/hyperwolf/regions/components/addRegion";
import ReorderIcon from '@mui/icons-material/Reorder';
import HyperwolfMainStrains from 'layouts/hyperwolf/manageMainStrains';
import AddHyperwolfStrain from 'layouts/hyperwolf/manageStrains/AddStrain';
import AddHyperwolfBanner from 'layouts/hyperwolf/manageHyperwolfBanners/AddBanner';
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import HyperwolfProducts from 'layouts/hyperwolf/products';
import AddProductHyperwolf from 'layouts/hyperwolf/products/addProduct';
import AddHyperwolfCategory from 'layouts/hyperwolf/manageCategories/addWebCategory';
import StorefrontIcon from '@mui/icons-material/Storefront';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import CreateBreak from 'layouts/hyperwolf/Break/createBreak';
import Approval from 'layouts/hyperwolf/Approval';
import DriverDetails from 'layouts/hyperwolf/Driver/driverDetails';
import AddDriver from 'layouts/hyperwolf/Driver/AddDriver/addDriver';
import AddBreak from 'layouts/hyperwolf/Break/AddBreak/addBreak';
import AddCannabinoid from 'layouts/cannabinoids/addCannabinoid';
import ManageCannabinoids from 'layouts/cannabinoids/manageCannabinoids';
import AddMainCannabinoid from 'layouts/cannabinoids/manageCannabinoids/AddMainCannabinoid';
import AddCannabinoidBanner from 'layouts/cannabinoids/manageCannabinoids/ManageMainCannabinoidBanners/AddCannabinoidBanner';
import MainPageCannbinoid from 'layouts/cannabinoids/manageCannabinoids/MainPageCannabinoid';
import React, { Suspense, lazy } from 'react';
const HyperDriveHomePage = lazy(() => import('layouts/Hyperdrive'));
const SiteSetting = lazy(() => import('layouts/Hyperdrive/SiteSetting'));
const DriverAnalyticsDetails = lazy(() => import('layouts/Hyperdrive/DriverAnalytics/DriverDetails'));

import HyperwolfOrders from 'layouts/hyperwolf/orders';
import HyperwolfOrderDetailsPage from 'layouts/hyperwolf/orders/orderDetails';
import HyperwolfMembers from 'layouts/hyperwolf/members';
import HyperwolfMemberDetails from 'layouts/hyperwolf/members/memberDetails';
import HyperdriveLoading from 'common/HyperdriveLoading';
import ManageRefund from 'layouts/manageRefund';
import ManageRefundIcon from 'common/customIcons/manageRefund';
import IndexLegal from 'layouts/legalPages';
import EditLegalPage from 'layouts/legalPages/EditLegalPage';
import StaticPagesIcon from 'common/customIcons/staticPgaesIcon';
import ProductTraits from 'layouts/productTraits';
import AddTrait from 'layouts/productTraits/addTrait/addTrait';
import ProductSubTraits from 'layouts/productTraits/subTraits';
import AddSubTrait from 'layouts/productTraits/subTraits/addSubTrait/addSubTrait';
import EditEEATPage from 'layouts/legalPages/EditEEATPages';
import LegalPageDetails from 'layouts/legalPages/LegalPagesDetails';
import ProductTraitIcon from 'common/customIcons/productTrait';
import ProductIconInner from 'common/customIcons/productIconInner';
import AddMemberHyperwolf from 'layouts/hyperwolf/members/addMember';
import StoresIcon from 'common/customIcons/storeIcon';
import Stores from 'layouts/stores';
import StoreDetails from 'layouts/stores/storeDetails';
import AddStore from 'layouts/stores/addStore';
import { STILO } from 'utilities/constants';
import WalletPayment from 'common/customIcons/walletPayment';
import ManageWalletPayment from 'layouts/manageWalletPayment';
import IndexBlog from 'layouts/blog';
import AddBlogPage from 'layouts/blog/AddBlog';
import BlogDetailsView from 'layouts/blog/blog-details-view';
import BlogIcon from 'common/customIcons/blogIcon';
import AuthorIcon from 'common/customIcons/authorIcon';
import PhysicianIcon from 'common/customIcons/physicianIcon';
import IndexPhysician from 'layouts/physician';
import AddPhysician from 'layouts/physician/addPhysician';
import ManagePaymentSetting from 'layouts/hyperwolf/managePaymentSetting';
import TaxManagementIcon from 'common/customIcons/tax_management';
import IndexMetrc from 'layouts/Metrc';
import DistributionConfig from 'layouts/distributionSetting/distributionConfig';
import DistributionIcon from 'common/customIcons/distribution';
import AgingDiscountedProducts from 'layouts/distributionSetting/agingProducts';
import ScheduledTimeSlot from 'layouts/hyperwolf/TimeSlotManagement/scheduledTimeSlot';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import KitTemplate from 'layouts/distributionSetting/kitTemplate';
import UserAndRoles from "layouts/hyperwolf/userAndRoles";

import AssignProductsToTemplateKit from "components/distributionSetting/kitTemplate/components/assignProducts";
import CreateTemplate from "components/distributionSetting/kitTemplate/components/createTemplate";
import ViewTemplate from "components/distributionSetting/kitTemplate/components/viewTemplate";
import DriverListPage from "components/distributionSetting/driverKitVerification/components/driverList";
import UpdateDistributionProducts from "components/distributionSetting/distributionManagement/components/updateDistributionProducts";
import UpdateRefillProducts from "components/distributionSetting/refillLogs/components/updateRefillProducts";
import ManageBoxes from "components/distributionSetting/boxes";
import CreateBox from "components/distributionSetting/boxes/components/createBox";
import BoxDetails from "components/distributionSetting/boxes/components/boxDetails";
import RefillLogs from "components/distributionSetting/refillLogs";
import DriverKitVerification from "components/distributionSetting/driverKitVerification";
import DistributionManagement from "components/distributionSetting/distributionManagement";
import AddDistribution from "components/distributionSetting/distributionManagement/addDistribution";
import DistributionDetails from "components/distributionSetting/distributionManagement/distributionDetails";
import AddProductDistribution from "components/distributionSetting/distributionManagement/addProductDistribution";
import AddRegionKit from "components/distributionSetting/distributionManagement/addRegionKit";
import RefillDetails from "components/distributionSetting/refillLogs/components/refillDetails";
import AddProductRefill from "components/distributionSetting/refillLogs/addProductRefill";

import IndexHyperdriveTesting from 'layouts/hyperwolf/HyperdriveTestingPanel.js';
import AsapIndex from 'layouts/hyperwolf/ASAP/AsapIndex';
import DriverKitDetails from "components/distributionSetting/driverKitVerification/components/driverKitDetails";
import KitReport from "components/distributionSetting/driverKitVerification/components/kitReport";
import LossPreventionIcon from "common/customIcons/lossPrevention";
import DiscrepancyManagementIcon from "common/customIcons/discrepancyManagement";
import DiscrepancyManagement from "components/distributionSetting/discrepancyManagement";
import ManageBoxesIcon from 'common/customIcons/manageBoxes';
import ClosureFormsIcon from "common/customIcons/closureForms";
import ClosureForms from "components/distributionSetting/closerForms";
import RegionClosureForms from "components/distributionSetting/closerForms/components/regionClosureForms";
import ClosureFormDetails from "components/distributionSetting/closerForms/components/details";
import RevenueConciliation from "components/distributionSetting/closerForms/components/revenueConciliation";
import ClosureFormReport from "components/distributionSetting/closerForms/components/finalReport";
import DiscrepancyApprovalsIcon from "common/customIcons/discrepancyApprovals";
import DiscrepancyApprovals from "components/distributionSetting/discrepancyApprovals";
import ManagePlatformsIcon from 'common/customIcons/ManagePlatforms';
import ShopTimingIcon from 'common/customIcons/shopTiming';
import WasteInventoryIcon from "common/customIcons/wasteInventory";
import WasteInventory from "components/distributionSetting/wasteInventory";
import HomeBannerManage from 'layouts/hyperwolf/BannerManagement/HomeBannerManage';
import BannerManagementIcon from 'common/customIcons/bannerManagement';
import HolidaysLogs from 'layouts/hyperwolf/BannerManagement/Holidays/HolidaysLogs';
import BRBLogs from 'layouts/hyperwolf/BannerManagement/BRB/BRBLogs';
import Createholiday from 'layouts/hyperwolf/BannerManagement/Holidays/Createholiday';
import CreateBRB from 'layouts/hyperwolf/BannerManagement/BRB/CreateBRB';
import EditBRBImage from 'layouts/hyperwolf/BannerManagement/BRB/EditBRB';
import EditHolidayPage from 'layouts/hyperwolf/BannerManagement/Holidays/EditHoliday';
import EditHolidayByDate from 'layouts/hyperwolf/BannerManagement/Holidays/EditHolidayByDate';
import HomePage from 'components/homePage';
import HomePageIcon from 'common/customIcons/homePage';
import CreateHome from 'components/homePage/createHome';
import LocationPage from 'components/landingPage';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import RolesPermissions from 'layouts/rolesPermissions';
import AddRoles from 'layouts/rolesPermissions/addRoles';
import AddUsers from 'layouts/rolesPermissions/addUser';
import CreateLocation from 'components/landingPage/createLanding';
import ViewLanding from 'components/landingPage/viewLanding';
import ViewHome from 'components/homePage/viewHome';
import AddSubCategory from 'layouts/hyperwolf/manageCategories/AddSubCategory';
import ViewLocation from 'components/landingPage/viewLanding';
import ProductCarousels from 'layouts/hyperwolf/ProductCarousels';
import AddCarousel from 'layouts/hyperwolf/ProductCarousels/AddCarousel';
import ProductCarouselsIcon from 'common/customIcons/productCarousels';
import AuthorListing from 'layouts/author/Listing'
import AddAuthorPage from 'layouts/author/AddAuthor'
import ViewAuthorPage from 'layouts/author/ViewAuthorPage'

import BrandIcon from 'common/customIcons/brandIcon';
import DistributorIcon from 'common/customIcons/distributorIcon';
import HyperwolfBrands from 'layouts/hyperwolf/brands';
import AddHyperwolfBrand from 'layouts/hyperwolf/brands/addBrand';
import BrandDetails from 'layouts/hyperwolf/brands/details';
import Distributors from 'layouts/distributor';
import AddDistributor from 'layouts/distributor/addDistributor/addDistributor';
import DistributorDetails from 'layouts/distributor/details';
import CardSetting from 'components/CardSetting/index.js';
import { PromotionRule } from 'layouts/promo/PromotionRule';
import PromoDashboard from 'layouts/promo/PromoDashboard';
import AddPromotions from 'layouts/promo/AddPromotions';
import PromoDetails from 'layouts/promo/PromoDetails';

import HyperwolfMainBrand from 'layouts/hyperwolf/manageMainBrands';
const adminsMode = JSON.parse(localStorage.getItem('adminsMode'))

const routes = [
  {
    type: 'collapse',
    name: 'Dashboard',
    key: 'dashboard',
    icon: <DashboardIcon />,
    route: '/dashboard',
    component: <Dashboard />,
    title: 'Dashboard'
  },
  {
    name: 'Add Store',
    key: 'stores/add',
    icon: <DashboardIcon />,
    route: 'stores/add',
    component: <AddStore />,
    screen: 'products',
    title: 'POS'
  },
  {
    name: 'Store Details',
    key: 'stores/details',
    icon: <MembersIcon />,
    route: '/stores/detail/:storeId',
    component: <StoreDetails />,
    title: 'POS'

  },
  {
    name: 'Store Details',
    key: 'stores/update',
    icon: <MembersIcon />,
    route: '/stores/:storeId',
    component: <AddStore />,
    title: 'POS'

  },
  {
    name: 'Update Prroduct',
    key: 'storeProducts/update',
    icon: <ProductIcon />,
    route: '/stores/detail/:storeId/products/:productId',
    component: <StoreProductDetailsPage />,
    title: "POS"
  },
  {
    type: 'collapse',
    name: 'POS',
    icon: <StoresIcon />,
    screen: 'products',
    title: "POS",
    collapse: [
      {
        type: 'collapse',
        name: 'Stores',
        key: 'stores',
        icon: <StoresIcon />,
        route: '/stores',
        component: <Stores />,
        screen: 'products',
        title: "POS",
      },
      {
        type: 'collapse',
        name: 'Approvals',
        key: 'approvals',
        icon: <ApprovalsIcon />,
        route: '/approvals',
        component: <Approvals />,
        screen: 'products',
        title: "POS",

      },
    ]
  },



  //product subtraits
  {
    name: 'Product SubTraits',
    key: 'productSubtraits',
    icon: <MastercatalogIcon />,
    route: 'product_traits/subtrait',
    component: <ProductSubTraits />,
    screen: 'products',
    title: "Product",
  },
  {
    name: 'Product SubTraits',
    key: 'productSubtraits',
    icon: <MastercatalogIcon />,
    route: 'product_traits/subtrait/add',
    component: <AddSubTrait />,
    title: "Product",
  },
  {
    name: 'Product SubTraits',
    key: 'productSubtraits',
    icon: <MastercatalogIcon />,
    route: 'product_traits/subtrait/:subtraitSlug',
    component: <AddSubTrait />,
    title: "Product",
  },
  {
    name: 'Product Traits',
    key: 'product_traits',
    icon: <ProductTraitIcon />,
    route: '/product_traits/add',
    title: "Product",
    component: <AddTrait />,
  },
  {
    name: 'Product Traits',
    key: 'product_traits',
    icon: <ProductTraitIcon />,
    route: '/product_traits/:traitSlug',
    title: "Product",
    component: <AddTrait />,
  },
  ////////////////////////////////////////////////

  {
    type: 'collapse',
    name: 'Products',
    icon: <ProductIcon />,
    screen: 'products',
    title: "Product",
    collapse: [
      {
        type: 'collapse',
        name: 'Products',
        key: 'products',
        icon: <ProductIconInner />,
        route: '/products',
        component: <Products />,
        screen: 'products',
        title: "Product",
      },
      {
        name: 'Product Traits',
        key: 'product_traits',
        icon: <ProductTraitIcon />,
        route: 'product_traits',
        component: <ProductTraits />,
        screen: 'products',
        title: "Product",
      },

      {
        name: 'Master Catalog',
        key: 'mastercatalog',
        icon: <MastercatalogIcon />,
        route: 'mastercatalog',
        component: <MasterCatalog mode='view' />,
        screen: 'products',
        title: "Product",
      },

      {
        type: 'collapse',
        name: 'Disclaimer',
        key: 'disclaimer',
        icon: <SettingsIcon />,
        route: '/disclaimer',
        component: <ManageDisclaimers />,
        screen: 'products',
        title: "Product",
      },
    ]
  },
  {
    name: 'Add StoreProducts',
    key: 'storeProducts/add',
    route: '/store/product/:storeId/add',
    component: <AddStoreProducts />,
    title: "POS",
  },
  {
    name: 'Add StoreProducts',
    key: 'storeProducts/add',
    route: '/store/product/:storeId/bulkadd',
    component: <MasterCatalogProductList />,
    title: "POS",
  },
  {
    name: 'Store Approvals',
    key: 'storeapprovals/approvalDetails',
    route: '/stores/detail/:storeId/:approvalId',
    component: <StoreApprovalDetails />,
    title: "POS",
  },
  {
    name: 'Add Product',
    key: 'products/add',
    icon: <ProductIcon />,
    route: '/products/add',
    component: <AddProduct />,
    title: "Product",
  },
  {
    name: 'Update Prroduct',
    key: 'products/update',
    icon: <ProductIcon />,
    route: '/products/:productId',
    component: <AddProduct />,
    title: "Product",
  },
  {
    name: 'Update Prroduct',
    key: 'products/update',
    icon: <ProductIcon />,
    title: "Product",
    route: '/products/details/:productId',
    component: <ProductDetails />,
  },
  {
    type: 'collapse',
    name: 'Inventory',
    key: 'inventories',
    icon: <InventoryIcon />,
    route: '/inventories',
    title: "Inventory",
    component: <Inventory />,
  },
  {
    name: 'Add Inventory',
    key: 'inventories/add',
    icon: <InventoryIcon />,
    route: '/inventories/add',
    component: <AddInventory />,
    title: "Inventory",
  },
  {
    name: 'Update Inventory',
    key: 'inventories/update',
    icon: <InventoryIcon />,
    route: '/inventories/:inventoryId',
    component: <AddInventory />,
    title: "Inventory",
  },
  {
    type: 'collapse',
    name: 'Orders',
    key: 'orders',
    icon: <OrdersIcon />,
    route: '/orders',
    title: "Orders",
    component: <Orders />,
  },
  {
    name: 'Orders',
    key: 'orders',
    icon: <OrdersIcon />,
    route: '/orders/member/:memberId',
    component: <MemberOrders />,
    title: "Orders",
  },
  {
    name: 'Orders',
    key: 'orders/add',
    icon: <OrdersIcon />,
    route: '/orders/add',
    component: <AddOrder />,
    title: "Orders",

  },
  {
    name: 'Orders',
    key: 'orders/update',
    icon: <OrdersIcon />,
    route: '/orders/:orderId',
    component: <AddOrder />,
    title: "Orders",
  },
  {
    name: 'Orders',
    key: 'orders/update',
    icon: <OrdersIcon />,
    route: '/orders/details/:orderId',
    title: "Orders",
    component: <OrderDetailsPage />,
  },
  {
    name: 'StoreOrders',
    key: 'storeOrders/update',
    icon: <OrdersIcon />,
    route: '/stores/detail/:storeId/orders/:orderId',
    component: <OrderDetailsPage />,
    title: "POS",
  },
  {
    type: 'collapse',
    name: 'Members',
    key: 'members',
    icon: <MembersIcon />,
    route: '/members',
    component: <Members />,
    title: "Members",
  },
  {
    name: 'Members Details',
    key: 'members/details',
    icon: <MembersIcon />,
    route: '/members/detail/:memberId',
    component: <MemberDetails />,
    title: "Members",
  },
  {
    name: 'Add Member',
    key: 'members/add',
    icon: <MembersIcon />,
    route: '/members/add',
    component: <AddMember />,
    title: "Members",
  },
  {
    name: 'Member Details',
    key: 'members/update',
    icon: <MembersIcon />,
    route: '/members/:memberId',
    title: "Members",
    component: <AddMember />,
  },
  {
    name: 'StoreMembers',
    key: 'storeMembers/update',
    icon: <MembersIcon />,
    route: '/stores/detail/:storeId/members/:memberId',
    component: <MemberDetails />,
    title: "POS",
  },

  // {
  //   name: 'Driver',
  //   key: 'hemp/driver',
  //   icon: <DriverIcon />,
  //   route: '/driver/create',
  //   component: <AddDriverHemp />,
  //   roles: ['Super Admin', 'Developer']
  // },
  // {
  //   name: 'Driver Hemp',
  //   key: 'stores/update',
  //   icon: <MembersIcon />,
  //   route: '/driver/:driverId',
  //   component: <AddDriverHemp />,
  //   roles: ['Super Admin', 'Developer', 'Shop Manager', 'Sales Associate', 'Customer Support']
  // },
  // {
  //   name: 'Driver Details Hemp',
  //   key: '/driver/details',
  //   icon: <MembersIcon />,
  //   route: '/driver/details/:driverId',
  //   component: <DriverDetailsHemp />,
  //   roles: ['Super Admin', 'Developer', 'Shop Manager', 'Sales Associate', 'Customer Support']
  // },
  // {
  //   name: 'Break',
  //   key: 'driver/break',
  //   icon: <DriverIcon />,
  //   route: '/break/create',
  //   component: <CreateBreakHemp />,
  //   roles: ['Super Admin', 'Developer', 'Shop Manager', 'Sales Associate', 'Customer Support']
  // },
  // {
  //   name: 'Break Details',
  //   key: '/driver/break/update',
  //   icon: <MembersIcon />,
  //   route: '/break/:breakId',
  //   component: <AddBreakHemp />,
  //   roles: ['Super Admin', 'Developer', 'Shop Manager', 'Sales Associate', 'Customer Support']
  // },
  // {
  //   name: 'Approval',
  //   key: 'hyperwolf/driver/approval',
  //   icon: <DriverIcon />,
  //   route: '',
  //   component: <ApprovalHemp />,
  //   roles: ['Super Admin', 'Developer', 'Shop Manager', 'Sales Associate', 'Customer Support']
  // },
  {
    type: 'collapse',
    name: 'Manage Website',
    icon: <CategoriesIcon />,
    screen: 'products',
    title: "Manage Website",
    collapse: [

      {
        type: 'collapse',
        name: 'Categories',
        key: 'categories',
        icon: <CategoriesIcon />,
        route: '/categories',
        component: <Categories />,
        screen: 'products',
        title: "Manage Website"
      },
      {
        type: 'collapse',
        name: 'Strains',
        key: 'strains',
        icon: <StrainsIcon />,
        route: '/strains',
        component: <Strains />,
        screen: 'products',
        title: "Manage Website"
      },

      {
        type: 'collapse',
        name: 'Cannabinoids',
        key: 'manage-cannabinoids',
        icon: <TerpenesIcon />,
        route: '/manage-cannabinoids',
        component: <ManageCannabinoids />,
        screen: 'products',
        // hidden: adminsMode === STILO, // Hide if mode is 'stilo'
        className: adminsMode === STILO && 'stilo-mode',
        title: "Manage Website"

      },
      {
        type: 'collapse',
        name: 'Brands',
        key: 'brands',
        icon: <BrandsIcon />,
        route: '/brands',
        component: <Brands />,
        screen: 'products',
        title: "Manage Website"
      },
      {
        type: 'collapse',
        name: 'Homepage FAQ',
        key: 'faqs',
        icon: <QuestionAnswer />,
        route: '/faqs',
        component: <MainFAQ />,
        screen: 'products',
        title: "Manage Website"
      },
      {
        type: 'collapse',
        name: 'Homepage Banners',
        key: 'homepage-banners',
        icon: <WallpaperRounded />,
        route: '/homepage-banners',
        component: <HomepageBanners />,
        screen: 'products',
        title: "Manage Website"
      },
      {
        type: 'collapse',
        name: 'Static Pages',
        key: 'manages/static',
        icon: <StaticPagesIcon />,
        route: '/manages/static',
        component: <IndexLegal />,
        screen: 'products',
        title: "Manage Website"
      },
      {
        type: 'collapse',
        name: 'Authors',
        key: 'manages/author',
        icon: <AuthorIcon />,
        route: '/manages/author',
        component: <AuthorListing />,
        screen: 'products',
        // className: adminsMode !== STILO && 'stilo-mode',
        title: "Manage Website"
      },
      {
        type: 'collapse',
        name: 'Blog',
        key: 'manages/blog',
        icon: <BlogIcon />,
        route: '/manages/blog',
        component: <IndexBlog />,
        screen: 'products',
        // className: adminsMode !== STILO && 'stilo-mode',
        title: "Manage Website"
      },
      // {
      //   type: 'collapse',
      //   name: 'Blog',
      //   key: 'manages/blog',
      //   icon: <BlogIcon />,
      //   route: '/manages/blog',
      //   component: <IndexBlog />,
      //   roles: ['Super Admin', 'Shop Admin', 'Developer', 'Inventory Manager', 'Marketing Manager'],
      //   screen: 'products',
      //   className: adminsMode !== STILO && 'stilo-mode',
      //   title: "Manage Website"
      // },
      // {
      //   type: 'collapse',
      //   name: 'Physician',
      //   key: 'manages/physician',
      //   icon: <PhysicianIcon />,
      //   route: '/manages/physician',
      //   component: <IndexPhysician />,
      //   roles: ['Super Admin', 'Shop Admin', 'Developer', 'Inventory Manager', 'Marketing Manager', 'Stilo Admin'],
      //   screen: 'products',
      //   className: adminsMode !== STILO && 'stilo-mode',
      //   title: "Manage Website"
      // },
    ]
  },
  {
    name: 'Blog',
    key: 'manages/blog',
    icon: <BlogIcon />,
    route: '/manages/blog/add',
    component: <AddBlogPage />,
    title: "Manage Website",
  },
  {
    name: 'Blog',
    key: 'manages/blog',
    icon: <BlogIcon />,
    route: '/manages/blog/:blogId/edit',
    component: <AddBlogPage />,
    title: "Manage Website",
  },
  {
    name: 'Blog',
    key: 'manages/blog',
    icon: <BlogIcon />,
    route: '/manages/blog/:blogId/view',
    component: <BlogDetailsView />,
    title: "Manage Website",
  },
  {
    name: 'Author',
    key: 'manages/author',
    icon: <AuthorIcon />,
    route: '/manages/author/add',
    component: <AddAuthorPage />,
    title: "Manage Website",
  },
  {
    name: 'Author',
    key: 'manages/author',
    icon: <AuthorIcon />,
    route: '/manages/author/:authorId/view',
    component: <ViewAuthorPage />,
    title: "Manage Website",
  },
  {
    name: 'Author',
    key: 'manages/author',
    icon: <AuthorIcon />,
    route: '/manages/author/:authorId/edit',
    component: <AddAuthorPage />,
    title: "Manage Website",
  },
  {
    name: 'Legal Pages',
    key: 'manages/static',
    icon: <StaticPagesIcon />,
    route: '/manages/static/edit/:legalId',
    component: <EditLegalPage />,
    title: "Manage Website"
  },
  {
    name: 'Legal Pages',
    key: 'manages/static',
    icon: <StaticPagesIcon />,
    route: '/manages/static/details/:legalId',
    component: <LegalPageDetails />,
    title: "Manage Website"
  },
  {
    name: 'Legal Pages',
    key: 'manages/static',
    icon: <StaticPagesIcon />,
    route: '/manages/static/add',
    component: <EditEEATPage />,
    title: "Manage Website"
  },
  // {
  //   name: 'Blog',
  //   key: 'manages/blog',
  //   icon: <BlogIcon />,
  //   route: '/manages/blog/add',
  //   component: <AddBlogPage />,
  //   roles: ['Super Admin', 'Shop Admin', 'Developer', 'Inventory Manager', 'Marketing Manager'],
  //   title: "Manage Website"
  // },
  // {
  //   name: 'Blog',
  //   key: 'manages/blog',
  //   icon: <BlogIcon />,
  //   route: '/manages/blog/:blogId/edit',
  //   component: <AddBlogPage />,
  //   roles: ['Super Admin', 'Shop Admin', 'Developer', 'Inventory Manager', 'Marketing Manager'],
  //   title: "Manage Website"
  // },
  // {
  //   name: 'Blog',
  //   key: 'manages/blog',
  //   icon: <BlogIcon />,
  //   route: '/manages/blog/:blogId/view',
  //   component: <BlogDetailsView />,
  //   roles: ['Super Admin', 'Shop Admin', 'Developer', 'Inventory Manager', 'Marketing Manager'],
  //   title: "Manage Website"
  // },
  {
    type: 'collapse',
    name: 'Promotions',
    // key: 'products',
    icon: <PromotionsIcon />,
    screen: 'products',
    title: "Promotions",
    collapse: [
      {
        type: 'collapse',
        name: 'Promotions',
        key: 'promotions',
        icon: <PromotionsIcon />,
        route: '/promotions',
        component: <Promotions />,
        screen: 'products',
        title: "Promotions"
      },
      {
        type: 'collapse',
        name: 'Membership',
        key: 'memberships',
        icon: <WorkspacePremium />,
        route: '/memberships',
        component: <MemberShips />,
        screen: 'products',
        title: "Promotions"
      },
      {
        type:'collapse',
        name:'Common Promotions',
        key:'promo1',
        icon:<InventoryIcon/>,
        route: '/promoDashboard',
        component: <PromoDashboard/>,
        title:"Promotions"
      }
    ]
  },
  {
    type: 'collapse',
    name: 'Settings',
    key: 'settings',
    icon: <SettingsIcon />,
    screen: 'settings',
    title: "Settings",
    collapse: [
      {
        type: 'collapse',
        name: 'Roles and Permissions',
        key: 'roles-permissions',
        icon: <ManageAccountsIcon />,
        route: '/roles-permissions',
        component: <RolesPermissions />,
        screen: 'settings',
        title: "Settings"
      },
      // {
      //   type: 'collapse',
      //   name: 'Users and Roles',
      //   key: 'user-roles',
      //   icon: <ManageAccountsIcon />,
      //   route: '/user-roles',
      //   component: <UsersAndRoles />,
      //   roles: ['Super Admin', 'Shop Admin', 'Developer'],
      //   screen: 'settings',
      // },
      {
        type: 'collapse',
        name: 'Regions',
        key: 'regions',
        icon: <RegionsIcon />,
        route: '/regions',
        component: <Regions />,
        screen: 'settings',
        title: "Settings"
      },

      {
        type: 'collapse',
        name: 'Manage Platforms',
        key: 'manages/registration',
        icon: <ManagePlatformsIcon />,
        route: '/manages/registration',
        component: <ManageSignupType />,
        screen: 'settings',
        title: "Settings"
      },
      {
        type: 'collapse',
        name: 'Manage Refund',
        key: 'manages/refund',
        icon: <ManageRefundIcon />,
        route: '/manages/refund',
        component: <ManageRefund />,
        screen: 'settings',
        title: "Settings"
      },
      {
        type: 'collapse',
        name: 'Manage Wallet and Payment',
        key: 'manages/wallet-payment',
        icon: <WalletPayment />,
        route: '/manages/wallet-payment',
        component: <ManageWalletPayment />,
        screen: 'settings',
        title: "Settings"
      },
      {
        type: 'collapse',
        name: 'Product Carousels',
        key: 'hyperwolf/product-carousels',
        icon: <ProductCarouselsIcon />,
        route: '/hyperwolf/product-carousels',
        component: <ProductCarousels />,
        screen: 'settings',
        title: "Settings",
      },

      {
        type: 'collapse',
        name: 'Physician',
        key: 'manages/physician',
        icon: <PhysicianIcon />,
        route: '/manages/physician',
        component: <IndexPhysician />,
        screen: 'products',
        className: adminsMode !== STILO && 'stilo-mode',
        title: "Settings"
      },
    ]
  },
  {
    name: 'Add Carousel',
    key: 'hyperwolf/product-carousels/add',
    route: '/hyperwolf/product-carousels/add',
    component: <AddCarousel />,
    title: "Settings",
  },
  {
    name: 'Roles',
    key: 'roles',
    route: '/roles-permissions/add-roles',
    component: <AddRoles />,
    title: "Settings",
  },
  {
    name: 'Roles',
    key: 'roles',
    route: '/roles-permissions/edit-roles/:roleId',
    component: <AddRoles />,
    title: "Settings",
  },
  {
    name: 'Users',
    key: 'users',
    route: '/roles-permissions/add-user',
    component: <AddUsers />,
    title: "Settings",
  },
  {
    name: 'add Category',
    key: 'categories/add',
    icon: <CategoriesIcon />,
    route: '/categories/add',
    component: <AddCategory />,
    title: "Manage Website",
  },
  {
    name: 'update Category',
    key: 'categories/update',
    icon: <CategoriesIcon />,
    route: '/categories/:categoryId',
    component: <AddCategory />,
    title: "Manage Website",
  },

  {
    name: 'add strains',
    key: '/strains ',
    icon: <StrainsIcon />,
    route: '/strains/add',
    component: <AddStrain />,
    title: "Manage Website",
  },
  {
    name: 'add strains',
    key: '/strains ',
    icon: <StrainsIcon />,
    route: '/strains/:strainId',
    component: <AddStrain />,
    title: "Manage Website",
  },
  {
    name: 'add strains',
    key: '/strains ',
    icon: <StrainsIcon />,
    route: '/strains/main-strain',
    component: <AddMainStrain />,
    title: "Manage Website",
  },
  {
    name: 'Manage Categories',
    key: '/manageCategories ',
    icon: <CategoriesIcon />,
    // route: '/manageCategories/add',
    route: '/categories/manageCategories/add',
    component: <AddWebCategory />,
    title: "Manage Website",
  },
  {
    name: 'Manage Categories',
    key: '/manageCategories ',
    icon: <CategoriesIcon />,
    // route: '/manageCategories/:webCategoryId',
    route: '/categories/manageCategories/:webCategoryId',
    title: "Manage Website",
    component: <AddWebCategory />,
  },
  {
    name: 'Brands',
    key: 'brands/add',
    icon: <BrandsIcon />,
    route: '/brands/add',
    component: <AddBrand />,
    title: "Manage Website",
  },
  {
    name: 'Main Brand',
    key: 'brands/main-brand',
    icon: <BrandsIcon />,
    route: '/brands/main-brand',
    title: "Manage Website",
    component: <AddMainBrand />,
  },
  {
    name: 'Brands Update',
    key: 'brands/update',
    icon: <BrandsIcon />,
    route: '/brands/:brandId',
    component: <AddBrand />,
    title: "Manage Website",
  },
  {
    name: 'add Region',
    key: 'regions/add',
    icon: <RegionsIcon />,
    route: '/regions/add',
    component: <AddRegion />,
    title: "Settings",
  },
  {
    name: 'edit Region',
    key: 'regions/update',
    icon: <RegionsIcon />,
    route: '/regions/:regionId',
    title: "Settings",
    component: <AddRegion />,
  },
  {
    name: 'Main Cannabinoids',
    key: 'manage-cannabinoids/main-cannabinoid',
    icon: <TerpenesIcon />,
    route: '/manage-cannabinoids/main-cannabinoid',
    component: <AddMainCannabinoid />,
    title: "Manage Website",
  },
  {
    name: 'Canabanoids',
    key: 'cannabinoids',
    icon: <TerpenesIcon />,
    route: '/cannabinoids/add',
    component: <AddCannabinoid />,
    title: "Manage Website",
  },
  {
    name: 'Canabanoids',
    key: 'cannabinoids',
    icon: <TerpenesIcon />,
    route: '/cannabinoids/:cannabinoidId',
    title: "Manage Website",
    component: <AddCannabinoid />,
  },
  {
    name: 'Main Cannabinoids',
    key: 'manage-cannabinoids/main-cannabinoid',
    icon: <TerpenesIcon />,
    route: '/manage-cannabinoids/main-cannabinoid',
    component: <AddMainCannabinoid />,
    title: "Manage Website",
  },
  {
    name: 'Main Cannabinoids',
    key: 'manage-cannabinoids/add-main-cannabinoid-banner',
    icon: <TerpenesIcon />,
    route: '/manage-cannabinoids/add-main-cannabinoid-banner',
    component: <AddCannabinoidBanner />,
    title: "Manage Website",
  },
  {
    name: 'Main Cannabinoids',
    key: 'manage-cannabinoids/add-main-cannabinoid-banner',
    icon: <TerpenesIcon />,
    route: '/manage-cannabinoids/add-main-cannabinoid-banner/:bannerId',
    component: <AddCannabinoidBanner />,
    title: "Manage Website",
  },
  {
    name: 'Main Cannabinoids',
    key: 'manage-cannabinoids/main-cannabinoid/main-page',
    icon: <TerpenesIcon />,
    route: '/manage-cannabinoids/main-cannabinoid/main-page',
    title: "Manage Website",
    component: <MainPageCannbinoid />,
  },
  {
    name: 'Add Homepage Banners',
    key: 'add-homepage-banners',
    icon: <WallpaperRounded />,
    route: '/homepage-banners/add',
    component: <AddBanner />,
    title: "Manage Website",
  },
  {
    name: 'Add Homepage Banners',
    key: 'update-homepage-banners',
    icon: <WallpaperRounded />,
    route: '/homepage-banners/:bannerId',
    component: <AddBanner />,
    title: "Manage Website",
  },
  {
    name: 'Add Promotion',
    key: 'promotions',
    icon: <PromotionsIcon />,
    route: '/promotions/add',
    component: <AddPromotion />,
    title: "Promotions",
  },
   {
    name: 'Add Promotion',
    key: 'promotions',
    icon: <PromotionsIcon />,
    route: '/promotions/adds',
    component: <AddPromotions />,
    title: "Promotions",
  },
  {
    name: 'Add Promotion',
    key: 'promotions',
    icon: <PromotionsIcon />,
    route: '/promotions/adds/:promoId',
    component: <AddPromotions />,
    title: "Promotions",
  },
  {
    name: 'Add Promotion',
    key: 'promotions',
    icon: <PromotionsIcon />,
    route: '/promotions/:promotionId',
    component: <AddPromotion />,
    title: "Promotions",
  },
  {
    name: 'Add Promotion',
    key: 'promotions',
    icon: <PromotionsIcon />,
    route: '/promotions/:promotionId/details',
    component: <PromotionDetails />,
    title: "Promotions",
  },
  {
    name: 'Add Promotion',
    key: 'promotions',
    icon: <PromotionsIcon />,
    route: '/promotions/details/:promoId',
    component: <PromoDetails />,
    title: "Promotions",
  },
  {
    name: 'Membership',
    key: 'membership',
    icon: <WorkspacePremium />,
    route: '/memberships/add',
    component: <AddMemberShip />,
    title: "Promotions",
  },
  {
    name: 'Membership',
    key: 'membership',
    icon: <WorkspacePremium />,
    route: '/memberships/:memberShipId/update',
    component: <AddMemberShip />,
    title: "Promotions",
  },

  {
    name: 'Roles',
    key: 'roles',
    route: '/roles-permissions/add-user/:roleId',
    component: <AddUsers />,
    title: "Settings",
  },
  // {
  //   name: 'Physician',
  //   key: 'physician',
  //   route: '/manages/physician/add',
  //   component: <AddPhysician />,
  //   roles: ['Super Admin', 'Developer']
  // },
  // {
  //   name: 'Physician',
  //   key: 'physician',
  //   route: '/manages/physician/:physicianId',
  //   component: <AddPhysician />,
  //   roles: ['Super Admin', 'Developer']

  // },
];

export const hyperfwolfAdminRoutes = [
  {
    type: 'collapse',
    name: 'Manage Website',
    icon: <CategoriesIcon />,
    screen: 'products',
    title: "Manage Website",
    collapse: [
      // {
      //   type: 'collapse',
      //   name: 'Manage States',
      //   key: 'homepage',
      //   icon: <HomePageIcon />,
      //   route: '/homepage',
      //   component: <HomePage />,
      //   screen: 'products',
      //   title: "Manage Website",
      // },
      // {
      //   type: 'collapse',
      //   name: 'Manage Cities',
      //   key: 'locationPage',
      //   icon: <LocationOnIcon />,
      //   route: '/locationPage',
      //   component: <LocationPage />,
      //   screen: 'products',
      //   title: "Manage Website",
      // },
      // {
      //   type: 'collapse',
      //   name: 'Default Home Page',
      //   key: 'defaultpage',
      //   icon: <HomePageIcon />,
      //   route: '/defaultHomepage/view',
      //   component: <ViewHome isDefaultHomePage={true} />,
      //   screen: 'products',
      //   title: "Manage Website",
      // },
      {
        // type: 'collapse',
        name: 'Cannabinoids',
        key: 'manage-cannabinoids',
        icon: <TerpenesIcon />,
        route: '/manage-cannabinoids',
        component: <ManageCannabinoids />,
        screen: 'products',
        title: "Manage Website",
      },
      {
        // type: 'collapse',
        name: 'Manage Main Strains',
        key: 'hyperwolf/manage_main_strain',
        icon: <ReorderIcon />,
        route: '/hyperwolf/manage_main_strain',
        component: <HyperwolfMainStrains />,
        screen: 'products',
        title: "Manage Website",
      },

      {
        type: 'collapse',
        name: 'Categories',
        key: 'categories',
        icon: <CategoriesIcon />,
        route: '/categories',
        component: <Categories />,
        screen: 'products',
        title: "Manage Website"
      },
      // {
      //   type: 'collapse',
      //   name: 'Manage Categories',
      //   key: 'hyperwolf/manage-categories',
      //   icon: <DashboardIcon />,
      //   route: '/hyperwolf/manage-categories',
      //   component: <ManageHyperwolfCategories />,
      //   title: "Manage Website",
      // },

      // {
      //   type: 'collapse',
      //   name: 'Manage Categories',
      //   key: 'hyperwolf/manage-categories',
      //   icon: <DashboardIcon />,
      //   route: '/hyperwolf/manage-categories',
      //   component: <ManageHyperwolfCategories />,
      //   title: "Manage Website",
      // },
      {
        type: 'collapse',
        name: 'Static Pages',
        key: 'manages/static',
        icon: <StaticPagesIcon />,
        route: '/manages/static',
        component: <IndexLegal />,
        title: "Manage Website",
        screen: 'products',
      },
      {
        type: 'collapse',
        name: 'Authors',
        key: 'manages/author',
        icon: <AuthorIcon />,
        route: '/manages/author',
        component: <AuthorListing />,
        screen: 'products',
        // className: adminsMode !== STILO && 'stilo-mode',
        title: "Manage Website"
      },
      {
        type: 'collapse',
        name: 'Blog',
        key: 'manages/blog',
        icon: <BlogIcon />,
        route: '/manages/blog',
        component: <IndexBlog />,
        screen: 'products',
        // className: adminsMode !== STILO && 'stilo-mode',
        title: "Manage Website"
      },
    ]
  },
  {
    name: 'Manage Categories',
    key: '/manageCategories ',
    icon: <CategoriesIcon />,
    route: '/categories/manageCategories/add',
    component: <AddWebCategory />,
    title: "Manage Website",
  },
  {
    name: 'Manage Categories',
    key: '/manageCategories ',
    icon: <CategoriesIcon />,
    route: '/categories/manageCategories/:webCategoryId',
    component: <AddWebCategory />,
    title: "Manage Website",
  },
  {
    name: 'add Category',
    key: 'categories/add',
    icon: <CategoriesIcon />,
    route: '/categories/add',
    component: <AddCategory />,
    title: "Manage Website",
  },
  {
    name: 'update Category',
    key: 'categories/update',
    icon: <CategoriesIcon />,
    route: '/categories/:categoryId',
    component: <AddCategory />,
    title: "Manage Website",
  },

  {
    name: 'Legal Pages',
    key: 'manages/static',
    icon: <StaticPagesIcon />,
    route: '/manages/static/edit/:legalId',
    title: "Manage Website",
    component: <EditLegalPage />,
  },
  {
    name: 'Legal Pages',
    key: 'manages/static',
    icon: <StaticPagesIcon />,
    route: '/manages/static/details/:legalId',
    title: "Manage Website",
    component: <LegalPageDetails />,
  },
  {
    name: 'Legal Pages',
    key: 'manages/static',
    icon: <StaticPagesIcon />,
    route: '/manages/static/add',
    component: <EditEEATPage />,
    title: "Manage Website",
  },
  {
    // type: 'collapse',
    name: 'Canabanoids',
    key: 'cannabinoids',
    icon: <TerpenesIcon />,
    route: '/cannabinoids/add',
    component: <AddCannabinoid />,
    title: "Manage Website",
    // screen: 'products'
  },
  {
    name: 'Canabanoids',
    key: 'cannabinoids',
    icon: <TerpenesIcon />,
    route: '/cannabinoids/:cannabinoidId',
    component: <AddCannabinoid />,
    title: "Manage Website",
  },
  {
    name: 'Main Cannabinoids',
    key: 'manage-cannabinoids/main-cannabinoid',
    icon: <TerpenesIcon />,
    route: '/manage-cannabinoids/main-cannabinoid',
    component: <AddMainCannabinoid />,
    title: "Manage Website",
  },
  {
    name: 'Main Cannabinoids',
    key: 'manage-cannabinoids/add-main-cannabinoid-banner',
    icon: <TerpenesIcon />,
    route: '/manage-cannabinoids/add-main-cannabinoid-banner',
    component: <AddCannabinoidBanner />,
    title: "Manage Website",
  },
  {
    name: 'Main Cannabinoids',
    key: 'manage-cannabinoids/add-main-cannabinoid-banner',
    icon: <TerpenesIcon />,
    route: '/manage-cannabinoids/add-main-cannabinoid-banner/:bannerId',
    component: <AddCannabinoidBanner />,
    title: "Manage Website",
  },
  {
    name: 'Main Cannabinoids',
    key: 'manage-cannabinoids/main-cannabinoid/main-page',
    icon: <TerpenesIcon />,
    route: '/manage-cannabinoids/main-cannabinoid/main-page',
    component: <MainPageCannbinoid />,
    title: "Manage Website",
  },
  {
    name: 'Manage Categories',
    key: 'hyperwolf/manage-categories',
    icon: <TerpenesIcon />,
    route: '/hyperwolf/manage-categories/add-page',
    component: <AddHyperwolfCategory />,
    title: "Manage Website",
  },
  {
    name: 'Manage Categories',
    key: 'hyperwolf/manage-categories',
    icon: <TerpenesIcon />,
    route: '/hyperwolf/manage-categories/edit-sub',
    component: <AddSubCategory />,
    title: "Manage Website",
  },
  // {
  //   name: 'Manage Main Strains',
  //   key: 'hyperwolf/manage_strains/add-page',
  //   icon: <TerpenesIcon />,
  //   route: '/hyperwolf/manage_strains/add-page',
  //   component: <AddHyperwolfStrain />,
  //   title: "Manage Website",
  // },

  {
    name: 'Manage Main Strains',
    key: 'hyperwolf/manage_strains/add-page',
    icon: <TerpenesIcon />,
    route: '/hyperwolf/manage_strains/add-page',
    component: <AddHyperwolfStrain />,
    title: "Manage Website",
  },
  {
    name: 'Manage Main Strains',
    key: 'hyperwolf/manage_strains/add-page',
    icon: <TerpenesIcon />,
    route: '/hyperwolf/manage_strains/add-page/:strainId',
    component: <AddHyperwolfStrain />,
    title: "Manage Website",
  },
  {
    name: 'Home Page',
    key: 'homepage/add',
    icon: <ProductIcon />,
    route: '/homepage/add',
    component: <CreateHome />,
    title: "Manage Website",
  },
  {
    name: 'Home Page',
    key: 'homePage/edit',
    icon: <ProductIcon />,
    route: '/homePage/edit/:id',
    component: <CreateHome />,
    title: "Manage Website",
  },
  {
    name: 'Home Page',
    key: 'homePage/edit',
    icon: <ProductIcon />,
    route: '/defaultHomepage/edit',
    component: <CreateHome isDefaultHomePage={true} />,
    title: "Manage Website",
  },
  {
    name: 'Home Page',
    key: 'homePage/view',
    icon: <ProductIcon />,
    route: '/homePage/view/:id',
    component: <ViewHome />,
    title: "Manage Website",
  },
  {
    name: 'Location Page',
    key: 'locationPage/add',
    icon: <ProductIcon />,
    route: '/locationPage/add',
    component: <CreateLocation />,
    title: "Manage Website",
  },
  {
    name: 'Location Page',
    key: 'locationPage/view',
    icon: <ProductIcon />,
    route: '/locationPage/view/:locationId',
    component: <ViewLocation />,
    title: "Manage Website",
  },
  {
    name: 'Location Page',
    key: 'locationPage/add',
    icon: <ProductIcon />,
    route: '/locationPage/edit/:locationId',
    component: <CreateLocation />,
    title: "Manage Website",
  },
  {
    name: 'Blog',
    key: 'manages/blog',
    icon: <BlogIcon />,
    route: '/manages/blog/add',
    component: <AddBlogPage />,
    title: "Manage Website",
  },
  {
    name: 'Blog',
    key: 'manages/blog',
    icon: <BlogIcon />,
    route: '/manages/blog/:blogId/edit',
    component: <AddBlogPage />,
    title: "Manage Website",
  },
  {
    name: 'Blog',
    key: 'manages/blog',
    icon: <BlogIcon />,
    route: '/manages/blog/:blogId/view',
    component: <BlogDetailsView />,
    title: "Manage Website",
  },
  {
    name: 'Author',
    key: 'manages/author',
    icon: <AuthorIcon />,
    route: '/manages/author/add',
    component: <AddAuthorPage />,
    title: "Manage Website",
  },
  {
    name: 'Author',
    key: 'manages/author',
    icon: <AuthorIcon />,
    route: '/manages/author/:authorId/view',
    component: <ViewAuthorPage />,
    title: "Manage Website",
  },
  {
    name: 'Author',
    key: 'manages/author',
    icon: <AuthorIcon />,
    route: '/manages/author/:authorId/edit',
    component: <AddAuthorPage />,
    title: "Manage Website",
  },
  {
    type: 'collapse',
    name: 'Products',
    icon: <ProductIcon />,
    screen: 'products',
    title: "Product",
    collapse: [
      {
        type: 'collapse',
        name: 'Products',
        key: 'hyperwolf/products',
        icon: <ProductIconInner />,
        route: '/hyperwolf/products',
        component: <HyperwolfProducts />,
        screen: 'products',
        title: "Product",
      },
      {
        name: 'Product Traits',
        key: 'product_traits',
        icon: <ProductTraitIcon />,
        route: 'product_traits',
        component: <ProductTraits />,
        screen: 'products',
        title: "Product",
      },
      {
        type: 'collapse',
        name: 'Brands',
        key: 'hyperwolf/brands',
        icon: <BrandIcon />,
        route: '/hyperwolf/brands',
        // component: <HyperwolfBrands />,
        component: <HyperwolfMainBrand />,
        screen: 'products',
        title: "Product",
      },
      {
        type: 'collapse',
        name: 'Distributors',
        key: 'hyperwolf/distributors',
        icon: <DistributorIcon />,
        route: '/hyperwolf/distributors',
        component: <Distributors />,
        screen: 'products',
        title: "Product",
      },
      {
        type: 'collapse',
        name: 'Disclaimer',
        key: 'disclaimer',
        icon: <SettingsIcon />,
        route: '/disclaimer',
        title: "Product",
        component: <ManageDisclaimers />,
        screen: 'products',
      },
    ]
  },
  {
    name: 'Brands',
    key: 'hyperwolf/brands',
    icon: <BrandIcon />,
    route: '/hyperwolf/brands/add',
    component: <AddHyperwolfBrand />,
    title: "Product",
    screen: 'products',
  },
  {
    name: 'Add Product',
    key: 'hyperwolf/products/add',
    icon: <ProductIcon />,
    route: '/hyperwolf/products/add',
    component: <AddProductHyperwolf />,
    title: "Product",
    screen: 'products',
  },
  {
    name: 'Edit Product',
    key: 'hyperwolf/products/edit',
    icon: <ProductIcon />,
    route: '/hyperwolf/products/edit/:productId',
    component: <AddProductHyperwolf />,
    title: "Product",
    screen: 'products',
  },
  {
    name: 'Brands',
    key: 'hyperwolf/brands/edit',
    icon: <BrandIcon />,
    route: '/hyperwolf/brands/edit',
    component: <AddHyperwolfBrand />,
    title: "Product",
    screen: 'products',
  },
  {
    // type: 'collapse',
    name: 'Brands',
    key: 'hyperwolf/brands',
    icon: <brands />,
    route: '/hyperwolf/brands',
    component: <HyperwolfMainBrand />,
    screen: 'products',
    title: "products",
  },
  {
    name: 'Brands',
    key: 'hyperwolf/brands/view',
    icon: <brands />,
    route: '/hyperwolf/brands/:brandId',
    component: <BrandDetails />,
    title: "Product",
    screen: 'products',
  },
  {
    name: 'Distributors',
    key: 'hyperwolf/distributors',
    icon: <DistributorIcon />,
    route: '/hyperwolf/distributors/add',
    component: <AddDistributor />,
    title: "Product",
    screen: 'products',
  },
  {
    name: 'Distributors',
    key: 'hyperwolf/distributors',
    icon: <DistributorIcon />,
    route: '/hyperwolf/distributors/:distributorId',
    component: <DistributorDetails />,
    title: "Product",
    screen: 'products',
  },
  {
    name: 'Distributors',
    key: 'hyperwolf/distributors',
    icon: <DistributorIcon />,
    route: '/hyperwolf/distributors/:distributorId/edit',
    component: <AddDistributor />,
    title: "Product",
    screen: 'products',
  },
  {
    name: 'Product Traits',
    key: 'product_traits',
    icon: <ProductTraitIcon />,
    route: '/product_traits/add',
    component: <AddTrait />,
    title: "Product",
  },
  {
    name: 'Product Traits',
    key: 'product_traits',
    icon: <ProductTraitIcon />,
    route: '/product_traits/:traitSlug',
    component: <AddTrait />,
    title: "Product",
  },
  {
    name: 'Product SubTraits',
    key: 'productSubtraits',
    icon: <MastercatalogIcon />,
    route: 'product_traits/subtrait',
    component: <ProductSubTraits />,
    title: "Product",
    screen: 'products',
  },
  {
    name: 'Product SubTraits',
    key: 'productSubtraits',
    icon: <MastercatalogIcon />,
    route: 'product_traits/subtrait/:subtraitSlug',
    component: <AddSubTrait />,
    title: "Product",
  },
  {
    name: 'Product SubTraits',
    key: 'productSubtraits',
    icon: <MastercatalogIcon />,
    route: 'product_traits/subtrait/add',
    component: <AddSubTrait />,
    title: "Product",
  },
  {
    name: 'Update Prroduct',
    key: 'products/update',
    icon: <ProductIcon />,
    route: '/hyperwolf/products/details/:productId',
    component: <HyperwolfProductDetails />,
    title: "Product",
  },

  {
    type: 'collapse',
    name: 'Employees',
    key: 'hyperwolf/manage-employess',
    icon: <MembersIcon />,
    route: '/hyperwolf/manage-employess',
    component: <ManageEmployees />,
    title: "Employees",
  },
  {
    name: 'Manage Employess',
    key: 'hyperwolf/manage-employess/add',
    icon: <MembersIcon />,
    route: '/hyperwolf/manage-employess/add',
    component: <AddEmployee />,
    title: "Employees",
  },
  // {
  //   name: 'Manage Sub Strains',
  //   key: 'hyperwolf/manage_strains/add',
  //   icon: <ReorderIcon />,
  //   route: '/hyperwolf/manage_strains/add',
  //   component: <AddHyperwolfStrain />,
  //   title: "Manage Webiste",
  // },
  // {
  //   name: 'Settings',
  //   key: 'hyperwolf/main-banners/add',
  //   icon: <ViewCarouselIcon />,
  //   screen: 'settings',
  //   route: '/hyperwolf/main-banners/add',
  //   component: <AddHyperwolfBanner />,
  //   roles: ['Super Admin', 'Shop Admin', 'Shop Manager', 'Inventory Manager', 'Marketing Manager', 'Developer', 'Customer Support', "Sales Associate"],
  // },
  {
    type: 'collapse',
    name: 'Members',
    key: 'hyperwolf_members',
    icon: <MembersIcon />,
    route: 'hyperwolf/members',
    title: "Members",
    component: <HyperwolfMembers />,
  },
  {
    name: 'Members Details',
    key: 'hyperwolfMembers/details',
    icon: <MembersIcon />,
    route: 'hyperwolf/members/detail/:memberEmail',
    component: <HyperwolfMemberDetails />,
    title: "Members",
  },
  {
    name: 'Member Details',
    key: 'hyperwolfMembers/update',
    icon: <MembersIcon />,
    route: '/hyperwolf/members/:memberEmail',
    component: <AddMemberHyperwolf />,
    title: "Members",
  },

  {
    type: 'collapse',
    name: 'Orders',
    key: 'hyperwolf_orders',
    icon: <OrdersIcon />,
    route: '/hyperwolf/orders',
    component: <HyperwolfOrders />,
    title: "Orders",
  },
  {
    name: 'Orders',
    key: 'orders',
    icon: <OrdersIcon />,
    route: '/orders/member/:memberId',
    component: <MemberOrders />,
    title: "Orders",
  },
  {
    name: 'Orders',
    key: 'orders/add',
    icon: <OrdersIcon />,
    route: '/orders/add',
    component: <AddOrder />,
    title: "Orders",
  },
  {
    name: 'Orders',
    key: 'orders/update',
    icon: <OrdersIcon />,
    route: '/orders/:orderId',
    component: <AddOrder />,
    title: "Orders",
  },
  {
    name: 'Orders',
    key: 'orders/update',
    icon: <OrdersIcon />,
    route: 'hyperwolf/orders/details/:orderId',
    component: <HyperwolfOrderDetailsPage />,
    title: "Orders",
  },
  {
    name: 'Hyperdrive',
    key: 'hyperdrive',
    // route: '/hyperdrive',
    route: `/${process.env.REACT_APP_MODE}/hyperdrive`,
    component: <HyperDrive />,
  },
  {
    type: 'collapse',
    name: 'Driver/Breaks',
    key: 'hyperwolf/driver',
    icon: <DriverIcon />,
    route: '/hyperwolf/driver',
    component: <HyperwolfAdmin />,
    title: "Drivers/Breaks",
  },

  {
    name: 'Driver',
    key: 'hyperwolf/driver',
    icon: <DriverIcon />,
    route: '/hyperwolf/driver/create',
    component: <AddDriver />,
    title: "Drivers/Breaks",
  },
  {
    name: 'Store Details',
    key: 'stores/update',
    icon: <MembersIcon />,
    route: '/hyperwolf/driver/:driverId',
    component: <AddDriver />,
    title: "Drivers/Breaks",
  },
  {
    name: 'Driver Details',
    key: 'hyperwolf/driver/details',
    icon: <MembersIcon />,
    route: '/hyperwolf/driver/details/:driverId',
    component: <DriverDetails />,
    title: "Drivers/Breaks",
  },
  {
    name: 'Break',
    key: 'hyperwolf/driver/break',
    icon: <DriverIcon />,
    route: '/hyperwolf/break/create',
    component: <CreateBreak />,
    title: "Drivers/Breaks",
  },
  {
    name: 'Approval',
    key: 'hyperwolf/driver/approval',
    icon: <DriverIcon />,
    route: '',
    component: <Approval />,
    title: "Drivers/Breaks",
  },
  {
    name: 'Store Details',
    key: 'hyperwolf/driver/update',
    icon: <MembersIcon />,
    route: '/hyperwolf/break/:breakId',
    component: <AddBreak />,
    title: "Drivers/Breaks",
  },
  // {
  //   type: 'collapse',
  //   name: 'Settings',
  //   key: 'hyperwolf/shop_timing',
  //   icon: <SettingsIcon />,
  //   route: '/hyperwolf/shop_timing',
  //   component: <HyperwolfShopTiming />,
  //   roles: ['Super Admin', 'Shop Admin', 'Shop Manager', 'Inventory Manager', 'Marketing Manager', 'Developer', 'Customer Support', "Sales Associate"]
  // },
  {
    type: 'collapse',
    name: 'Settings',
    key: 'settings',
    icon: <SettingsIcon />,
    screen: 'settings',
    title: "Settings",
    collapse: [

      {
        type: 'collapse',
        name: 'Roles and Permissions',
        key: 'roles-permissions',
        icon: <ManageAccountsIcon />,
        route: '/manages/roles-permissions',
        component: <RolesPermissions />,
        screen: 'settings',
        title: "Settings"
      },
      {
        type: 'collapse',
        name: 'Manage Platforms',
        key: 'manages/registration',
        icon: <ManagePlatformsIcon />,
        route: '/manages/registration',
        component: <ManageSignupType />,
        screen: 'settings',
        title: "Settings",
      },
      {
        type: 'collapse',
        name: 'Hyperdrive Setting',
        key: 'hyperwolf/shop_timing',
        icon: <StorefrontIcon />,
        route: '/hyperwolf/shop_timing',
        component: <HyperwolfShopTiming />,
        screen: 'settings',
        title: "Settings",
      },
      {
        type: 'collapse',
        name: 'Payment Setting',
        key: 'hyperwolf/payment-setting',
        icon: <ManageRefundIcon />,
        route: '/hyperwolf/payment-setting',
        component: <ManagePaymentSetting />,
        screen: 'settings',
        title: "Settings",
      },
      {
        type: 'collapse',
        name: 'Scheduled Time Slots',
        key: 'hyperwolf/payment-setting',
        icon: <AccessTimeFilledIcon />,
        route: '/hyperwolf/scheduled-time-slot',
        component: <ScheduledTimeSlot />,
        screen: 'settings',
        title: "Settings",
      },
      // {
      //   type: 'collapse',
      //   name: 'Testing Panel',
      //   key: 'hyperwolf/HyperdriveTesting',
      //   icon: <ManageRefundIcon />,
      //   route: '/hyperwolf/HyperdriveTesting',
      //   component: <IndexHyperdriveTesting />,
      //   roles: ['Super Admin', 'Shop Admin', 'Shop Manager', 'Inventory Manager', 'Marketing Manager', 'Developer', 'Customer Support', "Sales Associate"],
      //   screen: 'settings',
      //   title: "Settings",
      // },
      {
        type: 'collapse',
        name: 'Shop Timing',
        key: 'hyperwolf/asap-time-slot',
        icon: <StorefrontIcon />,
        route: '/hyperwolf/asap-time-slot',
        component: <AsapIndex />,
        screen: 'settings',
        title: "Settings",
      },
      {
        type: 'collapse',
        name: 'Centralized Banner Management',
        key: 'hyperwolf/banner-manage',
        icon: <BannerManagementIcon />,
        route: '/hyperwolf/banner-manage',
        component: <HomeBannerManage />,
        screen: 'settings',
        title: "Settings",
      },
      {
        type: 'collapse',
        name: 'Product Carousels',
        key: 'hyperwolf/product-carousels',
        icon: <ProductCarouselsIcon />,
        route: '/hyperwolf/product-carousels',
        component: <ProductCarousels />,
        screen: 'settings',
        title: "Settings",
      },

      // {
      //   type: 'collapse',
      //   name: 'Shop Timing',
      //   key: 'hyperwolf/asap-time-slot',
      //   icon: <AccessTimeFilledIcon />,
      //   route: '/hyperwolf/asap-time-slot',
      //   component: <AsapIndex />,
      //   roles: ['Super Admin', 'Shop Admin', 'Shop Manager', 'Inventory Manager', 'Marketing Manager', 'Developer', 'Customer Support', "Sales Associate"],
      //   screen: 'settings',
      // },
      {
        type: 'collapse',
        name: 'Credit Card Fee Settings',
        key: 'cardSetting',
        icon: <CreditCardIcon />,
        route: '/cardSetting',
        component: <CardSetting />,
        screen: 'settings',
        title: "Settings",
      },
    ]
  },
  {
    name: 'Add Carousel',
    key: 'hyperwolf/product-carousels/add',
    route: '/hyperwolf/product-carousels/add',
    component: <AddCarousel />,
    title: "Settings",
  },
  {
    name: 'view Region',
    key: 'regions/view',
    icon: <RegionsIcon />,
    route: '/regions/view/:regionId',
    component: <ViewHyperwolfRegion />,
    title: "Inventory Distribution",
  },
  {
    name: 'add Region',
    key: 'regions/add',
    icon: <RegionsIcon />,
    route: '/regions/add',
    component: <AddHyperwolfRegion />,
    title: "Inventory Distribution",
  },
  {
    name: 'edit Region',
    key: 'regions/update/:regionId',
    icon: <RegionsIcon />,
    route: '/regions/update/:regionId',
    component: <AddHyperwolfRegion />,
    title: "Inventory Distribution",
  },
  {
    name: 'add SubRegion',
    key: 'subregions/add',
    icon: <RegionsIcon />,
    route: '/subregions/add',
    component: <AddHyperwolfSubRegion />,
    title: "Inventory Distribution",
  },
  {
    name: 'Edit SubRegion',
    key: 'subregions/update/:subRegionId',
    icon: <RegionsIcon />,
    route: '/subregions/update/:subRegionId',
    component: <AddHyperwolfSubRegion />,
    title: "Inventory Distribution",
  },
  // inventory distribution
  {
    type: 'collapse',
    name: 'Inventory Distribution',
    key: 'distributionSetting',
    icon: <DistributionIcon />,
    screen: 'distributionSetting',
    title: "Inventory Distribution",
    collapse: [
      {
        name: 'Manage Boxes',
        key: 'hyperwolf/boxes',
        icon: <ManageBoxesIcon />,
        route: '/hyperwolf/boxes',
        component: <ManageBoxes />,
        screen: 'distributionSetting',
        title: "Inventory Distribution",

      },
      {
        name: 'Distribution Config',
        key: 'hyperwolf/distributionConfig',
        icon: <DistributionConfigIcon />,
        route: '/hyperwolf/distributionConfig',
        component: <DistributionConfig />,
        screen: 'distributionSetting',
        title: "Inventory Distribution",

      },
      {
        type: 'collapse',
        name: 'Aging and Promotional Products',
        key: 'hyperwolf/aging-discounted-products',
        icon: <AgingDiscountedProductsIcon />,
        route: '/hyperwolf/aging-discounted-products',
        component: <AgingDiscountedProducts />,
        screen: 'distributionSetting',
        title: "Inventory Distribution",

      },
      {
        type: 'collapse',
        name: 'Regions',
        key: 'regions',
        icon: <RegionsIcon />,
        route: '/regions',
        component: <HyperwolfRegions />,
        screen: 'distributionSetting',
        title: "Inventory Distribution",

      },
      {
        type: 'collapse',
        name: 'Kit Template',
        key: 'hyperwolf/kit-template',
        icon: <KitTemplateIcon />,
        route: '/hyperwolf/kit-template',
        component: <KitTemplate />,
        screen: 'distributionSetting',
        title: "Inventory Distribution",
        className: "sdfhsdfjbjsfjhdsbfjhbds"
      },
      {
        type: 'collapse',
        name: 'Distribution Management',
        key: 'hyperwolf/distribution-management',
        icon: <DistributionManagementIcon />,
        route: '/hyperwolf/distribution-management',
        component: <DistributionManagement />,
        screen: 'distributionSetting',
        title: "Inventory Distribution",

      },
      {
        type: 'collapse',
        name: 'Kit Refill Logs',
        key: 'hyperwolf/refill-logs',
        icon: <KitRefillLogsIcon />,
        route: '/hyperwolf/refill-logs',
        component: <RefillLogs />,
        screen: 'distributionSetting',
        title: "Inventory Distribution",

      },
      {
        type: 'collapse',
        name: 'Driver Kit Verification',
        key: 'hyperwolf/driver-kit-verification',
        icon: <DriverKitVerificationIcon />,
        route: '/hyperwolf/driver-kit-verification',
        component: <DriverKitVerification />,
        screen: 'distributionSetting',
        title: "Inventory Distribution",
      },

    ]
  },

  // {

  //   key: 'create-landing',
  //   icon: <ProductIcon />,
  //   route: '/create-landing',
  //   component: <CreateLocation />,
  //   title: "Settings",
  // },
  // {

  //   key: 'view-landing',
  //   icon: <ProductIcon />,
  //   route: '/view-landing',
  //   component: <ViewLanding />,
  //   title: "Settings",
  // },
  {

    key: 'view-home',
    icon: <ProductIcon />,
    route: '/view-home',
    component: <ViewHome />,
    title: "Settings",
  },
  {
    name: 'View Box',
    key: 'hyperwolf/boxes/view-box/:boxId',
    icon: <StorefrontIcon />,
    route: '/hyperwolf/boxes/view-box/:boxId',
    component: <BoxDetails />,
    title: "Inventory Distribution",
  },
  {
    name: 'Create Box',
    key: 'hyperwolf/boxes/create-box',
    icon: <StorefrontIcon />,
    route: '/hyperwolf/boxes/create-box',
    component: <CreateBox />,
    title: "Inventory Distribution",
  },
  {
    name: 'Update Box',
    key: 'hyperwolf/boxes/update-box/:boxId',
    icon: <StorefrontIcon />,
    route: '/hyperwolf/boxes/update-box/:boxId',
    component: <CreateBox />,
    title: "Inventory Distribution",
  },
  {
    name: 'Create Template',
    key: 'hyperwolf/kit-template/create-template',
    icon: <StorefrontIcon />,
    route: '/hyperwolf/kit-template/create-template',
    component: <CreateTemplate />,
    title: "Inventory Distribution",
  },
  {
    name: 'Assign Products',
    key: 'hyperwolf/kit-template/create-template/assign-products/:templateId',
    icon: <StorefrontIcon />,
    route: '/hyperwolf/kit-template/create-template/assign-products/:templateId',
    component: <AssignProductsToTemplateKit />,
    title: "Inventory Distribution",
  },
  {
    name: 'Update Template',
    key: 'hyperwolf/kit-template/update-template/:templateId',
    route: '/hyperwolf/kit-template/update-template/:templateId',
    icon: <StorefrontIcon />,
    component: <CreateTemplate />,
    title: "Inventory Distribution",
  },
  {
    name: 'Update Template',
    key: 'hyperwolf/kit-template/view-template/:templateId',
    route: '/hyperwolf/kit-template/view-template/:templateId',
    icon: <StorefrontIcon />,
    component: <ViewTemplate />,
    title: "Inventory Distribution",
  },
  
  {
    name: 'Add Distribution',
    key: 'hyperwolf/distribution-management/add-distribution',
    icon: <StorefrontIcon />,
    route: '/hyperwolf/distribution-management/add-distribution',
    component: <AddDistribution />,
    title: "Inventory Distribution",
    screen: 'distributionSetting',
  },
  {
    name: 'Update Distribution',
    key: 'hyperwolf/distribution-management/update-distribution/:distributionId',
    icon: <StorefrontIcon />,
    route: '/hyperwolf/distribution-management/update-distribution/:distributionId',
    component: <AddDistribution />,
    title: "Inventory Distribution",
    screen: 'distributionSetting',
  },
  {
    name: 'Distribution Details',
    key: 'hyperwolf/distribution-management/distribution-details/:distributionId',
    icon: <StorefrontIcon />,
    route: '/hyperwolf/distribution-management/distribution-details/:distributionId',
    component: <DistributionDetails />,
    title: "Inventory Distribution",
    screen: 'distributionSetting',
  },
  {
    name: 'Add Product',
    key: 'hyperwolf/distribution-management/add-distribution-product/:distributionId',
    icon: <StorefrontIcon />,
    route: '/hyperwolf/distribution-management/add-distribution-product/:distributionId',
    component: <AddProductDistribution />,
    title: "Inventory Distribution",
    screen: 'distributionSetting',
  },
  {
    name: 'Add Region Kit',
    key: 'hyperwolf/distribution-management/add-region-kit/:distributionId',
    icon: <StorefrontIcon />,
    route: '/hyperwolf/distribution-management/add-region-kit/:distributionId',
    component: <AddRegionKit />,
    title: "Inventory Distribution",
    screen: 'distributionSetting',
  },
  {
    name: 'Driver kit verification drivers',
    key: 'hyperwolf/driver-kit-verification/drivers/:distributionId',
    icon: <StorefrontIcon />,
    route: '/hyperwolf/driver-kit-verification/drivers/:distributionId',
    component: <DriverListPage />,
    title: "Inventory Distribution",
    screen: 'distributionSetting',
  },
  {
    name: 'Driver kit verification details',
    key: 'hyperwolf/driver-kit-verification/drivers/:distributionId/details/:driverId',
    icon: <StorefrontIcon />,
    route: '/hyperwolf/driver-kit-verification/drivers/:distributionId/details/:driverId',
    component: <DriverKitDetails />,
    title: "Inventory Distribution",
    screen: 'distributionSetting',
  },
  {
    name: 'Driver kit report',
    key: 'hyperwolf/driver-kit-verification/kit-report/:distributionId/:driverId',
    icon: <StorefrontIcon />,
    route: '/hyperwolf/driver-kit-verification/kit-report/:distributionId/:driverId',
    component: <KitReport />,
    title: "Inventory Distribution",
    screen: 'distributionSetting',
  },
  {
    name: 'Update Distribution Products',
    key: 'hyperwolf/distribution-management/manage-products/:action/:distributionId',
    icon: <StorefrontIcon />,
    route: '/hyperwolf/distribution-management/manage-products/:action/:distributionId',
    component: <UpdateDistributionProducts />,
    title: "Inventory Distribution",
    screen: 'distributionSetting',
  },
  {
    name: 'Refill log details',
    key: 'hyperwolf/refill-logs/:refillId',
    icon: <StorefrontIcon />,
    route: '/hyperwolf/refill-logs/:refillId',
    component: <RefillDetails />,
    title: "Inventory Distribution",
    screen: 'distributionSetting',
  },
    {
    name: 'Update Refill Products',
    key: 'hyperwolf/refill-logs/manage-products/:action/:distributionId',
    icon: <StorefrontIcon />,
    route: '/hyperwolf/refill-logs/manage-products/:action/:distributionId',
    component: <UpdateRefillProducts />,
    title: "Inventory Distribution",
    screen: 'distributionSetting',
  },
    {
    name: 'Add Product',
    key: 'hyperwolf/distribution-management/add-distribution-product/:distributionId',
    icon: <StorefrontIcon />,
    route: '/hyperwolf/refill-logs/add-refill-product/:distributionId',
    component: <AddProductRefill />,
    title: "Inventory Distribution",
    screen: 'distributionSetting',
  },
  // loss Prevention
  {
    type: 'collapse',
    name: 'Loss Prevention',
    icon: <LossPreventionIcon />,
    screen: 'lossPrevention',
    title: "Loss Prevention",
    collapse: [
      {
        name: 'Closure Forms',
        key: 'hyperwolf/closure-forms',
        icon: <ClosureFormsIcon />,
        route: '/hyperwolf/closure-forms',
        component: <ClosureForms />,
        title: "Loss Prevention",
        screen: 'lossPrevention',
      },
      {
        type: 'collapse',
        name: 'Discrepancy Management',
        key: 'hyperwolf/discrepancy-management',
        icon: <DiscrepancyManagementIcon />,
        route: '/hyperwolf/discrepancy-management',
        component: <DiscrepancyManagement />,
        title: "Loss Prevention",
        screen: 'lossPrevention',
      },
      {
        type: 'collapse',
        name: 'Discrepancy Approvals',
        key: 'hyperwolf/discrepancy-approvals',
        icon: <DiscrepancyApprovalsIcon />,
        route: '/hyperwolf/discrepancy-approvals',
        component: <DiscrepancyApprovals />,
        title: "Loss Prevention",
        screen: 'lossPrevention',
      },
      {
        type: 'collapse',
        name: 'Waste Inventory',
        key: 'hyperwolf/waste-inventory',
        icon: <WasteInventoryIcon />,
        route: '/hyperwolf/waste-inventory',
        component: <WasteInventory />,
        title: "Loss Prevention",
        screen: 'lossPrevention',
      },
    ]
  },
  {
    name: 'Region Closure forms',
    key: 'hyperwolf/closure-forms/region/:distributionId',
    icon: <StorefrontIcon />,
    route: '/hyperwolf/closure-forms/region/:distributionId',
    component: <RegionClosureForms />,
    title: "Loss Prevention",
    screen: 'distributionSetting',
  },
  {
    name: 'Region Closure details',
    key: 'hyperwolf/closure-forms/details/:distributionId',
    icon: <StorefrontIcon />,
    route: '/hyperwolf/closure-forms/details/:distributionId',
    component: <ClosureFormDetails />,
    title: "Loss Prevention",
    screen: 'distributionSetting',
  },
  {
    name: 'Revenue Reconciliation',
    key: 'hyperwolf/closure-forms/revenue-reconciliation/:distributionId',
    icon: <StorefrontIcon />,
    route: '/hyperwolf/closure-forms/revenue-reconciliation/:distributionId',
    component: <RevenueConciliation />,
    title: "Loss Prevention",
    screen: 'distributionSetting',
  },
  {
    name: 'Closure Form Final Report',
    key: 'hyperwolf/closure-forms/final-report/:distributionId',
    icon: <StorefrontIcon />,
    route: '/hyperwolf/closure-forms/final-report/:distributionId',
    component: <ClosureFormReport />,
    title: "Loss Prevention",
    screen: 'distributionSetting',
  },
  {
    key: 'hyperwolf/banner-manage',
    icon: <ProductIcon />,
    route: '/hyperwolf/banner-manage/add',
    component: <AddHyperwolfBanner />,
    title: "Settings",
  },
  {

    key: 'hyperwolf/banner-manage',
    icon: <ProductIcon />,
    route: '/hyperwolf/banner-manage/activity-logs',
    component: <HolidaysLogs />, title: "Settings",
  },
  {

    key: 'hyperwolf/banner-manage',
    icon: <ProductIcon />,
    route: '/hyperwolf/banner-manage/brb-activity-logs',
    component: <BRBLogs />, title: "Settings",
  },
  {

    key: 'hyperwolf/banner-manage',
    icon: <ProductIcon />,
    route: '/hyperwolf/banner-manage/holiday-add',
    component: <Createholiday />, title: "Settings",
  },
  {

    key: 'hyperwolf/banner-manage',
    icon: <ProductIcon />,
    route: '/hyperwolf/banner-manage/brb-add',
    component: <CreateBRB />, title: "Settings",
  },
  {

    key: 'hyperwolf/banner-manage',
    icon: <ProductIcon />,
    route: '/hyperwolf/banner-manage/brb-edit/:brbID',
    component: <EditBRBImage />, title: "Settings",
  },
  {

    key: 'hyperwolf/banner-manage',
    icon: <ProductIcon />,
    route: '/hyperwolf/banner-manage/holiday-edit/:holidayID',
    component: <EditHolidayPage />, title: "Settings",
  },
  {

    key: 'hyperwolf/banner-manage',
    icon: <ProductIcon />,
    route: '/hyperwolf/banner-manage/holiday-edit-date/:HolidayDate',
    component: <EditHolidayByDate />, title: "Settings",
  },
  {
    name: 'Roles and Permissions',
    key: 'roles-permissions/add-roles',
    route: '/roles-permissions/add-roles',
    component: <AddRoles />,
    title: "Settings",
  },
  {
    name: 'Roles and Permissions',
    key: 'roles',
    route: '/roles-permissions/edit-roles/:roleId',
    component: <AddRoles />,
    title: "Settings",
  },
  {
    name: 'Roles and Permissions',
    key: 'roles',
    route: '/roles-permissions/add-user',
    component: <AddUsers />, title: "Settings",
  },
  {
    name: 'Roles',
    key: 'roles',
    route: '/roles-permissions/add-user/:roleId',
    component: <AddUsers />,
    title: "Settings",
  },
];

export const hyperfDriveAdminRoutes = [
  {
    name: 'Home',
    key: 'hyperdrive_home',
    icon: <ViewCarouselIcon />,
    route: `/${process.env.REACT_APP_MODE}/hyperdrive/home`,
    component: (
      <Suspense fallback={<div><HyperdriveLoading /></div>}>
        <HyperDriveHomePage />
      </Suspense>
    ),
  },
  {
    name: 'Site Setting',
    key: 'site-setting',
    icon: <ViewCarouselIcon />,
    route: `/${process.env.REACT_APP_MODE}/hyperdrive/site-setting`,
    component: (
      <Suspense fallback={<div><HyperdriveLoading /></div>}>
        <SiteSetting />
      </Suspense>
    ),
  },
  {
    name: 'Driver Analytics',
    key: 'driver_analytics',
    icon: <ViewCarouselIcon />,
    route: `/${process.env.REACT_APP_MODE}/hyperdrive/driver-analytics/detail/:driverId`,
    component: (
      <Suspense fallback={<div><HyperdriveLoading /></div>}>
        <DriverAnalyticsDetails />
      </Suspense>
    ),
  },
];

export const stiloRoutes = [
  {
    type: 'collapse',
    name: 'Dashboard',
    key: 'dashboard',
    icon: <DashboardIcon />,
    route: '/dashboard',
    component: <Dashboard />,
    title: 'Dashboard'
  },
  {
    name: 'Add Store',
    key: 'stores/add',
    icon: <DashboardIcon />,
    route: 'stores/add',
    component: <AddStore />,
    screen: 'products',
    title: 'POS',
  },
  {
    name: 'Store Details',
    key: 'stores/details',
    icon: <MembersIcon />,
    route: '/stores/detail/:storeId',
    component: <StoreDetails />,
    title: 'POS',
  },
  {
    name: 'Store Details',
    key: 'stores/update',
    icon: <MembersIcon />,
    route: '/stores/:storeId',
    component: <AddStore />,
    title: 'POS',
  },
  {
    name: 'Update Prroduct',
    key: 'storeProducts/update',
    icon: <ProductIcon />,
    route: '/stores/detail/:storeId/products/:productId',
    component: <StoreProductDetailsPage />,
    title: 'POS',
  },
  {
    type: 'collapse',
    name: 'POS',
    icon: <StoresIcon />,
    screen: 'products',
    title: 'POS',
    collapse: [
      {
        type: 'collapse',
        name: 'Stores',
        key: 'stores',
        icon: <StoresIcon />,
        route: '/stores',
        component: <Stores />,
        screen: 'products',
        title: 'POS',
      },
      {
        type: 'collapse',
        name: 'Approvals',
        key: 'approvals',
        icon: <ApprovalsIcon />,
        route: '/approvals',
        component: <Approvals />,
        screen: 'products',
        title: 'POS',

      },
    ]
  },

  //product subtraits
  {
    name: 'Product SubTraits',
    key: 'productSubtraits',
    icon: <MastercatalogIcon />,
    route: 'product_traits/subtrait',
    component: <ProductSubTraits />,
    screen: 'products',
    title: "Product",
  },
  {
    name: 'Product SubTraits',
    key: 'productSubtraits',
    icon: <MastercatalogIcon />,
    route: 'product_traits/subtrait/add',
    component: <AddSubTrait />,
    title: "Product",
  },
  {
    name: 'Product SubTraits',
    key: 'productSubtraits',
    icon: <MastercatalogIcon />,
    route: 'product_traits/subtrait/:subtraitSlug',
    component: <AddSubTrait />,
    title: "Product",
  },
  {
    name: 'Product Traits',
    key: 'product_traits',
    icon: <ProductTraitIcon />,
    route: '/product_traits/add',
    component: <AddTrait />,
    title: "Product",
  },
  {
    name: 'Product Traits',
    key: 'product_traits',
    icon: <ProductTraitIcon />,
    route: '/product_traits/:traitSlug',
    component: <AddTrait />,
    title: "Product",
  },
  {
    type: 'collapse',
    name: 'Products',
    icon: <ProductIcon />,
    screen: 'products',
    title: "Product",
    collapse: [
      {
        type: 'collapse',
        name: 'Products',
        key: 'products',
        icon: <ProductIconInner />,
        route: '/products',
        component: <Products />,
        screen: 'products',
        title: "Product",
      },
      {
        name: 'Product Traits',
        key: 'product_traits',
        icon: <ProductTraitIcon />,
        route: 'product_traits',
        component: <ProductTraits />,
        screen: 'products',
        title: "Product",
      },

      {
        name: 'Master Catalog',
        key: 'mastercatalog',
        icon: <MastercatalogIcon />,
        route: 'mastercatalog',
        component: <MasterCatalog mode='view' />,
        screen: 'products',
        title: "Product",
      },

      {
        type: 'collapse',
        name: 'Disclaimer',
        key: 'disclaimer',
        icon: <SettingsIcon />,
        route: '/disclaimer',
        component: <ManageDisclaimers />,
        screen: 'products',
        title: "Product",
      },
    ]
  },
  {
    name: 'Add StoreProducts',
    key: 'storeProducts/add',
    route: '/store/product/:storeId/add',
    component: <AddStoreProducts />,
    title: "POS",
  },
  {
    name: 'Add StoreProducts',
    key: 'storeProducts/add',
    route: '/store/product/:storeId/bulkadd',
    component: <MasterCatalogProductList />,
    title: "POS",
  },
  {
    name: 'Store Approvals',
    key: 'storeapprovals/approvalDetails',
    route: '/stores/detail/:storeId/:approvalId',
    component: <StoreApprovalDetails />,
    title: "POS",
  },
  {
    name: 'Add Product',
    key: 'products/add',
    icon: <ProductIcon />,
    route: '/products/add',
    component: <AddProduct />,
    title: "Product",
  },
  {
    name: 'Update Prroduct',
    key: 'products/update',
    icon: <ProductIcon />,
    route: '/products/:productId',
    component: <AddProduct />,
    title: "Product",
  },
  {
    name: 'Update Prroduct',
    key: 'products/update',
    icon: <ProductIcon />,
    route: '/products/details/:productId',
    component: <ProductDetails />,
    title: "Product",
  },
  {
    type: 'collapse',
    name: 'Inventory',
    key: 'inventories',
    icon: <InventoryIcon />,
    route: '/inventories',
    component: <Inventory />,
    title: "Inventory",
  },
  {
    name: 'Add Inventory',
    key: 'inventories/add',
    icon: <InventoryIcon />,
    route: '/inventories/add',
    component: <AddInventory />,
    title: "Inventory",
  },
  {
    name: 'Update Inventory',
    key: 'inventories/update',
    icon: <InventoryIcon />,
    route: '/inventories/:inventoryId',
    component: <AddInventory />,
    title: "Inventory",
  },
  {
    type: 'collapse',
    name: 'Orders',
    key: 'orders',
    icon: <OrdersIcon />,
    route: '/orders',
    component: <Orders />,
    title: "Orders",
  },
  {
    name: 'Orders',
    key: 'orders',
    icon: <OrdersIcon />,
    route: '/orders/member/:memberId',
    component: <MemberOrders />,
    title: "Orders",
  },
  {
    name: 'Orders',
    key: 'orders/add',
    icon: <OrdersIcon />,
    route: '/orders/add',
    component: <AddOrder />,
  },
  {
    name: 'Orders',
    key: 'orders/update',
    icon: <OrdersIcon />,
    route: '/orders/:orderId',
    component: <AddOrder />,
    title: "Orders",
  },
  {
    name: 'Orders',
    key: 'orders/update',
    icon: <OrdersIcon />,
    route: '/orders/details/:orderId',
    component: <OrderDetailsPage />,
    title: "Orders",
  },
  {
    name: 'StoreOrders',
    key: 'storeOrders/update',
    icon: <OrdersIcon />,
    route: '/stores/detail/:storeId/orders/:orderId',
    component: <OrderDetailsPage />,
    title: "POS",
  },
  {
    type: 'collapse',
    name: 'Members',
    key: 'members',
    icon: <MembersIcon />,
    route: '/members',
    component: <Members />,
    title: "Members",
  },
  {
    name: 'Members Details',
    key: 'members/details',
    icon: <MembersIcon />,
    route: '/members/detail/:memberId',
    component: <MemberDetails />,
    title: "Members",
  },
  {
    name: 'Add Member',
    key: 'members/add',
    icon: <MembersIcon />,
    route: '/members/add',
    title: "Members",
    component: <AddMember />,
  },
  {
    name: 'Member Details',
    key: 'members/update',
    icon: <MembersIcon />,
    route: '/members/:memberId',
    component: <AddMember />,
    title: "Members",
  },
  {
    name: 'StoreMembers',
    key: 'storeMembers/update',
    icon: <MembersIcon />,
    route: '/stores/detail/:storeId/members/:memberId',
    component: <MemberDetails />,
    title: "POS",
  },

  //Hemp drivers 
  // {
  //   type: 'collapse',
  //   name: 'Driver/Breaks',
  //   key: 'hemp/driver',
  //   icon: <DriverIcon />,
  //   route: '/drivers',
  //   component: <DriverHemp />,
  //   roles: ['Super Admin', 'Developer']
  // },
  // {
  //   name: 'Driver',
  //   key: 'hemp/driver',
  //   icon: <DriverIcon />,
  //   route: '/driver/create',
  //   component: <AddDriverHemp />,
  //   roles: ['Super Admin', 'Developer']
  // },
  // {
  //   name: 'Driver Hemp',
  //   key: 'stores/update',
  //   icon: <MembersIcon />,
  //   route: '/driver/:driverId',
  //   component: <AddDriverHemp />,
  //   roles: ['Super Admin', 'Developer', 'Shop Manager', 'Sales Associate', 'Customer Support', 'Stilo Admin']
  // },
  // {
  //   name: 'Driver Details Hemp',
  //   key: '/driver/details',
  //   icon: <MembersIcon />,
  //   route: '/driver/details/:driverId',
  //   component: <DriverDetailsHemp />,
  //   roles: ['Super Admin', 'Developer', 'Shop Manager', 'Sales Associate', 'Customer Support', 'Stilo Admin']
  // },
  // {
  //   name: 'Break',
  //   key: 'driver/break',
  //   icon: <DriverIcon />,
  //   route: '/break/create',
  //   component: <CreateBreakHemp />,
  //   roles: ['Super Admin', 'Developer', 'Shop Manager', 'Sales Associate', 'Customer Support', 'Stilo Admin']
  // },
  // {
  //   name: 'Break Details',
  //   key: '/driver/break/update',
  //   icon: <MembersIcon />,
  //   route: '/break/:breakId',
  //   component: <AddBreakHemp />,
  //   roles: ['Super Admin', 'Developer', 'Shop Manager', 'Sales Associate', 'Customer Support', 'Stilo Admin']
  // },
  // {
  //   name: 'Approval',
  //   key: 'hyperwolf/driver/approval',
  //   icon: <DriverIcon />,
  //   route: '',
  //   component: <ApprovalHemp />,
  //   roles: ['Super Admin', 'Developer', 'Shop Manager', 'Sales Associate', 'Customer Support', 'Stilo Admin']
  // },
  {
    type: 'collapse',
    name: 'Manage Website',
    icon: <CategoriesIcon />,
    screen: 'products',
    title: "Manage Website",
    collapse: [
      {
        type: 'collapse',
        name: 'Categories',
        key: 'categories',
        icon: <CategoriesIcon />,
        route: '/categories',
        component: <Categories />,
        screen: 'products',
        title: "Manage Website"
      },
      {
        type: 'collapse',
        name: 'Strains',
        key: 'strains',
        icon: <StrainsIcon />,
        route: '/strains',
        component: <Strains />,
        screen: 'products',
        title: "Manage Website"
      },


      {
        type: 'collapse',
        name: 'Brands',
        key: 'brands',
        icon: <BrandsIcon />,
        route: '/brands',
        component: <Brands />,
        screen: 'products',
        title: "Manage Website"
      },
      {
        type: 'collapse',
        name: 'Homepage FAQ',
        key: 'faqs',
        icon: <QuestionAnswer />,
        route: '/faqs',
        component: <MainFAQ />,
        screen: 'products',
        title: "Manage Website"
      },
      {
        type: 'collapse',
        name: 'Homepage Banners',
        key: 'homepage-banners',
        icon: <WallpaperRounded />,
        route: '/homepage-banners',
        component: <HomepageBanners />,
        screen: 'products',
        title: "Manage Website"
      },
      {
        type: 'collapse',
        name: 'Static Pages',
        key: 'manages/static',
        icon: <StaticPagesIcon />,
        route: '/manages/static',
        component: <IndexLegal />,
        screen: 'products',
        title: "Manage Website"
      },
      {
        type: 'collapse',
        name: 'Authors',
        key: 'manages/author',
        icon: <AuthorIcon />,
        route: '/manages/author',
        component: <AuthorListing />,
        screen: 'products',
        // className: adminsMode !== STILO && 'stilo-mode',
        title: "Manage Website"
      },
      {
        type: 'collapse',
        name: 'Blog',
        key: 'manages/blog',
        icon: <BlogIcon />,
        route: '/manages/blog',
        component: <IndexBlog />,
        screen: 'products',
        className: adminsMode !== STILO && 'stilo-mode',
        title: "Manage Website"
      },
      // {
      //   type: 'collapse',
      //   name: 'Physician',
      //   key: 'manages/physician',
      //   icon: <PhysicianIcon />,
      //   route: '/manages/physician',
      //   component: <IndexPhysician />,
      //   roles: ['Super Admin', 'Shop Admin', 'Developer', 'Inventory Manager', 'Marketing Manager','Stilo Admin'],
      //   screen: 'products',
      //   className: adminsMode !== STILO && 'stilo-mode',
      //    title: "Manage Website"
      // },
    ]
  },
  {
    name: 'Legal Pages',
    key: 'manages/static',
    icon: <StaticPagesIcon />,
    route: '/manages/static/edit/:legalId',
    component: <EditLegalPage />,
    title: "Manage Website",
  },
  {
    name: 'Legal Pages',
    key: 'manages/static',
    icon: <StaticPagesIcon />,
    route: '/manages/static/details/:legalId',
    component: <LegalPageDetails />,
    title: "Manage Website",
  },
  {
    name: 'Legal Pages',
    key: 'manages/static',
    icon: <StaticPagesIcon />,
    route: '/manages/static/add',
    component: <EditEEATPage />,
    title: "Manage Website",
  },
  {
    name: 'Blog',
    key: 'manages/blog',
    icon: <BlogIcon />,
    route: '/manages/blog/add',
    component: <AddBlogPage />,
    title: "Manage Website",
  },
  {
    name: 'Blog',
    key: 'manages/blog',
    icon: <BlogIcon />,
    route: '/manages/blog/:blogId/edit',
    component: <AddBlogPage />,
    title: "Manage Website",
  },
  {
    name: 'Blog',
    key: 'manages/blog',
    icon: <BlogIcon />,
    route: '/manages/blog/:blogId/view',
    component: <BlogDetailsView />,
    title: "Manage Website",
  },
  {
    name: 'Author',
    key: 'manages/author',
    icon: <AuthorIcon />,
    route: '/manages/author/add',
    component: <AddAuthorPage />,
    title: "Manage Website",
  },
  {
    name: 'Author',
    key: 'manages/author',
    icon: <AuthorIcon />,
    route: '/manages/author/:authorId/view',
    component: <ViewAuthorPage />,
    title: "Manage Website",
  },
  {
    name: 'Author',
    key: 'manages/author',
    icon: <AuthorIcon />,
    route: '/manages/author/:authorId/edit',
    component: <AddAuthorPage />,
    title: "Manage Website",
  },
  {
    type: 'collapse',
    name: 'Promotions',
    // key: 'products',
    icon: <PromotionsIcon />,
    screen: 'products',
    title: "Promotions",
    collapse: [
      {
        type: 'collapse',
        name: 'Promotions',
        key: 'promotions',
        icon: <PromotionsIcon />,
        route: '/promotions',
        component: <Promotions />,
        title: "Promotions",
        screen: 'products',
      },
      {
        type: 'collapse',
        name: 'Membership',
        key: 'memberships',
        icon: <WorkspacePremium />,
        route: '/memberships',
        component: <MemberShips />,
        title: "Promotions",
        screen: 'products',
      },
    ]
  },
  {
    type: 'collapse',
    name: 'Settings',
    key: 'settings',
    icon: <SettingsIcon />,
    screen: 'settings',
    title: "Settings",
    collapse: [
      {
        type: 'collapse',
        name: 'Roles and Permissions',
        key: 'roles-permissions',
        icon: <ManageAccountsIcon />,
        route: '/roles-permissions',
        component: <RolesPermissions />,
        screen: 'settings',
        title: "Settings"
      },
      {
        type: 'collapse',
        name: 'Regions',
        key: 'regions',
        icon: <RegionsIcon />,
        route: '/regions',
        component: <Regions />,
        screen: 'settings',
        title: "Settings"
      },
      {
        type: 'collapse',
        name: 'Manage Platforms',
        key: 'manages/registration',
        icon: <ManagePlatformsIcon />,
        route: '/manages/registration',
        component: <ManageSignupType />,
        screen: 'settings',
        title: "Settings"
      },
      {
        type: 'collapse',
        name: 'Manage Refund',
        key: 'manages/refund',
        icon: <ManageRefundIcon />,
        route: '/manages/refund',
        component: <ManageRefund />,
        screen: 'settings',
        title: "Settings"
      },
      {
        type: 'collapse',
        name: 'Manage Wallet and Payment',
        key: 'manages/wallet-payment',
        icon: <WalletPayment />,
        route: '/manages/wallet-payment',
        component: <ManageWalletPayment />,
        screen: 'settings',
        title: "Settings"
      },
      {
        type: 'collapse',
        name: 'Physician',
        key: 'manages/physician',
        icon: <PhysicianIcon />,
        route: '/manages/physician',
        component: <IndexPhysician />,
        screen: 'products',
        className: adminsMode !== STILO && 'stilo-mode',
        title: "Settings"
      },
      {
        type: 'collapse',
        name: 'Product Carousels',
        key: 'hyperwolf/product-carousels',
        icon: <ProductCarouselsIcon />,
        route: '/hyperwolf/product-carousels',
        component: <ProductCarousels />,
        screen: 'settings',
        title: "Settings",
      },

      {
        type: 'collapse',
        name: 'METRC',
        key: 'manages/metrc',
        icon: <TaxManagementIcon />,
        route: '/manages/metrc',
        component: <IndexMetrc />,
        screen: 'products',
        className: adminsMode !== STILO && 'stilo-mode',
        title: "Settings"
      },
    ]
  },
  {
    name: 'Add Carousel',
    key: 'hyperwolf/product-carousels/add',
    route: '/hyperwolf/product-carousels/add',
    component: <AddCarousel />,
    title: "Settings",
  },
  {
    name: 'add Category',
    key: 'categories/add',
    icon: <CategoriesIcon />,
    route: '/categories/add',
    component: <AddCategory />,
    title: "Manage Website",
  },
  {
    name: 'update Category',
    key: 'categories/update',
    icon: <CategoriesIcon />,
    route: '/categories/:categoryId',
    component: <AddCategory />,
    title: "Manage Website",
  },

  {
    name: 'add strains',
    key: '/strains ',
    icon: <StrainsIcon />,
    route: '/strains/add',
    component: <AddStrain />,
    title: "Manage Website",
  },
  {
    name: 'add strains',
    key: '/strains ',
    icon: <StrainsIcon />,
    route: '/strains/:strainId',
    component: <AddStrain />,
    title: "Manage Website",
  },
  {
    name: 'add strains',
    key: '/strains ',
    icon: <StrainsIcon />,
    route: '/strains/main-strain',
    component: <AddMainStrain />,
    title: "Manage Website",
  },
  {
    name: 'Manage Categories',
    key: '/manageCategories ',
    icon: <CategoriesIcon />,
    route: '/categories/manageCategories/add',
    component: <AddWebCategory />,
    title: "Manage Website",
  },
  {
    name: 'Manage Categories',
    key: '/manageCategories ',
    icon: <CategoriesIcon />,
    route: '/categories/manageCategories/:webCategoryId',
    component: <AddWebCategory />,
    title: "Manage Website",
  },
  {
    name: 'Brands',
    key: 'brands/add',
    icon: <BrandsIcon />,
    route: '/brands/add',
    component: <AddBrand />,
    title: "Manage Website",
  },
  {
    name: 'Main Brand',
    key: 'brands/main-brand',
    icon: <BrandsIcon />,
    route: '/brands/main-brand',
    component: <AddMainBrand />,
    title: "Manage Website",
  },
  {
    name: 'Brands Update',
    key: 'brands/update',
    icon: <BrandsIcon />,
    route: '/brands/:brandId',
    component: <AddBrand />,
    title: "Manage Website",
  },
  {
    name: 'add Region',
    key: 'regions/add',
    icon: <RegionsIcon />,
    route: '/regions/add',
    component: <AddRegion />,
    title: "Settings",
  },
  {
    name: 'edit Region',
    key: 'regions/update',
    icon: <RegionsIcon />,
    route: '/regions/:regionId',
    component: <AddRegion />,
    title: "Settings",
  },

  {
    name: 'Add Homepage Banners',
    key: 'add-homepage-banners',
    icon: <WallpaperRounded />,
    route: '/homepage-banners/add',
    component: <AddBanner />,
    title: "Manage Website",
  },
  {
    name: 'Add Homepage Banners',
    key: 'update-homepage-banners',
    icon: <WallpaperRounded />,
    route: '/homepage-banners/:bannerId',
    component: <AddBanner />,
    title: "Manage Website",
  },
  {
    name: 'Add Promotion',
    key: 'promotions',
    icon: <PromotionsIcon />,
    route: '/promotions/add',
    component: <AddPromotion />,
    title: "Promotions",
  },
  {
    name: 'Add Promotion',
    key: 'promotions',
    icon: <PromotionsIcon />,
    route: '/promotions/:promotionId',
    component: <AddPromotion />,
    title: "Promotions",
  },
  {
    name: 'Add Promotion',
    key: 'promotions',
    icon: <PromotionsIcon />,
    route: '/promotions/:promotionId/details',
    component: <PromotionDetails />,
    title: "Promotions",
  },
  {
    name: 'Membership',
    key: 'membership',
    icon: <WorkspacePremium />,
    route: '/memberships/add',
    component: <AddMemberShip />,
    title: "Promotions",
  },
  {
    name: 'Membership',
    key: 'membership',
    icon: <WorkspacePremium />,
    route: '/memberships/:memberShipId/update',
    component: <AddMemberShip />,
    title: "Promotions",
  },

  {
    name: 'Physician',
    key: 'physician',
    route: '/manages/physician/add',
    component: <AddPhysician />,
  },
  {
    name: 'Physician',
    key: 'physician',
    route: '/manages/physician/:physicianId',
    component: <AddPhysician />,
    title: "Settings",
  },

  {
    name: 'Roles and Permissions',
    key: 'roles-permissions/add-roles',
    route: '/roles-permissions/add-roles',
    component: <AddRoles />,
    title: "Settings",
  },
  {
    name: 'Roles and Permissions',
    key: 'roles',
    route: '/roles-permissions/edit-roles/:roleId',
    component: <AddRoles />,
    title: "Settings",
  },
  {
    name: 'Roles and Permissions',
    key: 'roles',
    route: '/roles-permissions/add-user',
    component: <AddUsers />,
    title: "Settings",
  },
  {
    name: 'Roles',
    key: 'roles',
    route: '/roles-permissions/add-user/:roleId',
    component: <AddUsers />,
    title: "Settings",
  },
];

export default routes;











